///////////////////// IMPORTS
import * as THREE from 'three';
import { DecalGeometry } from 'three/examples/jsm/geometries/DecalGeometry.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader';
import {GainMapLoader, HDRJPGLoader} from '@monogrid/gainmap-js';

import { PMREMGenerator } from 'three/src/extras/PMREMGenerator';

import { USDZExporter } from 'three/examples/jsm/exporters/USDZExporter.js';
import { KTX2Loader } from 'three/examples/jsm/loaders/KTX2Loader';

import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module.js';
import { AppConfig } from '../../../../app_config';
var guiVar;
import('three/examples/jsm/libs/lil-gui.module.min.js').then(({ GUI }) => {
    guiVar = GUI;
});
const TWEEN = require('@tweenjs/tween.js');
var hdrJpgDefault;
import TextSprite from '@seregpie/three.text-sprite';
import * as Sentry from "@sentry/nextjs";
import {getCookie} from "cookies-next";
import { log } from '../../../logger';
let frames = 0, prevTime = performance.now();
var fullHeightTotal;
import dynamic from 'next/dynamic';


const Hammer = dynamic(() => import('hammerjs'), { ssr: false });
///////////////////// Declare variables
var packageTypeGlobal;
declare global {
    interface window {
        MyNamespace: any;
    }
}

let container: Element | null;
let camera: THREE.Camera;
let camera2: THREE.Camera;
let activeCamera: THREE.Camera;

let controls: any;
let renderer: THREE.WebGLRenderer;
let scene: THREE.Scene = undefined;

var bodyMainTextureSaved = null;
var bodyAlphaTextureSaved = null;
var bodyMetallicTextureSaved = null;

var decalMaterial = new THREE.MeshPhongMaterial({
    specular: 0x444444,
   map: null,
    //normalMap: decalNormal,
    normalScale: new THREE.Vector2(1, 1),
    shininess: 30,
    transparent: true,
    depthTest: true,
    depthWrite: false,
    polygonOffset: true,
    polygonOffsetFactor: -4,
    wireframe: false,
});

var decals: any = [];
var decalsNumber: any = [];
var mouseHelper: any;
var position = new THREE.Vector3();
var orientation = new THREE.Euler();
var size = new THREE.Vector3(10, 10, 10);

var params = {
    minScale: 0.1,
    maxScale: 0.4,
    rotate: true,
    clear: function() {
        removeDecals();
    },
};
const mixers: never[] = [];
const clock = new THREE.Clock();
var envMap;
var mesh: any;
var raycaster: any;
var line: any;

var intersection = {
    intersects: false,
    point: new THREE.Vector3(),
    normal: new THREE.Vector3(),
};
var mouse = new THREE.Vector2();
var intersects: any = [];

/// THREE Scene Comments Components
let decalMap = null;
//////////////////////////////////////////////////////// INIT
export function clearSceneFull() {
    window.onresize = null;
    if(scene){
        scene.clear();
        scene = undefined;
    }

    if(renderer){

        renderer.forceContextLoss();
        renderer.dispose();
        renderer=undefined;

    }

}


let mouseX = 0;
let mouseY;

let targetX;
let targetY;


// Mouse interaction variables
let previousMouseX = 0;
let rotationInDegrees = 0;

function onDocumentMouseMove(event) {
    if( rotationSetActive){
        const deltaX = event.clientX - previousMouseX;
        // Convert deltaX to rotation angle in degrees (adjust sensitivity as needed)
        const deltaRotationDegrees = deltaX * 0.3;
        rotationInDegrees += deltaRotationDegrees;
        const rotationRadians = THREE.MathUtils.degToRad(rotationInDegrees);
if(packageTypeGlobal === "glass-bottles"){

    // Convert degrees to radians for Three.js
    // const rotationRadians = THREE.MathUtils.degToRad(rotationInDegrees);
    if(scene.getObjectByName("BODY")){
        scene.getObjectByName("BODY").rotation.y = rotationRadians;
    }
    if(scene.getObjectByName("Label_TOP")){
        scene.getObjectByName("Label_TOP").rotation.y = rotationRadians;
    }
    if(scene.getObjectByName("LABEL_BODY")){
        scene.getObjectByName("LABEL_BODY").rotation.y = rotationRadians;
    }
    if(scene.getObjectByName("LABEK_BODY")){
        scene.getObjectByName("LABEK_BODY").rotation.y = rotationRadians;
    }
    if(scene.getObjectByName("Label_Main")){
        scene.getObjectByName("Label_Main").rotation.y = rotationRadians;
    }
    if(scene.getObjectByName("Vicko")){
        scene.getObjectByName("Vicko").rotation.y = rotationRadians;
    }




}else if(packageTypeGlobal === "drink-cups"){
    // const rotationRadians = THREE.MathUtils.degToRad(rotationInDegrees);
    scene.getObjectByName("BODY").rotation.y = THREE.MathUtils.degToRad(rotationInDegrees);
    scene.getObjectByName("Label").rotation.y = THREE.MathUtils.degToRad(rotationInDegrees);
}  else if(packageTypeGlobal === "plastic-drink-cups"){
    // const rotationRadians = THREE.MathUtils.degToRad(rotationInDegrees);
    scene.getObjectByName("BODY").rotation.y = THREE.MathUtils.degToRad(rotationInDegrees);
    scene.getObjectByName("Label").rotation.y = THREE.MathUtils.degToRad(rotationInDegrees);
} else {

    // Convert degrees to radians for Three.js
    // const rotationRadians = THREE.MathUtils.degToRad(rotationInDegrees);
    scene.getObjectByName("BODY").rotation.y = rotationRadians;


}

        previousMouseX = event.clientX;

        if(setAngleRotation !== undefined){

            setAngleRotation(Math.round(rotationInDegrees));
        }


    }

}

export function setXRotationCamera (valueX) {

    var newValueX = valueX*3.6;
    const rotationRadians = THREE.MathUtils.degToRad(newValueX);
  //  scene.getObjectByName("BODY").rotation.y = rotationRadians;
    scene.rotation.y=rotationRadians;


    // Convert degrees to radians for Three.js


}
function onDocumentMouseMoveX (event) {


    var percent100 = window.innerWidth/5;
    var percent1 = percent100/100;
    var destination = percent100/360;
    var currentPercent = event.clientX / 10 * destination;
    mouseX = Math.round(currentPercent*2);
    mouseY = (event.clientY - ( window.innerHeight / 2));

}

var typePluginInner = false;
var savedOriginalPackModel = null;
var savedOriginalOpeningModel = null;

var  hdrEquirect;
var  hdrEquirectDefault;
var fpsLowered = false;
var countPerformanceBad = 0;
var functionFPS = null;
var isPlugin = false;
function animate() {

    requestAnimationFrame( animate );
    if (rotationEnabled) {
        // Pokud chcete rotovat scénu kolem osy Y:
        scene.rotation.y += autoRotateSpeed;
        // Případně můžete přidat i rotaci kolem osy X nebo jiné logiky.
    }
    // FPS

    frames ++;
    const time = performance.now();


    if ( (time >= prevTime + 1000) &&!fpsLowered) {


        if(Math.round( ( frames * 1000 ) / ( time - prevTime ) ) < 15){
            countPerformanceBad++;
            if(countPerformanceBad > 5){

                if(packageTypeGlobal === "glass-bottles" && scene.getObjectByName("BODY")){

                    const textureLoader = new THREE.TextureLoader();
                    const normalMapTexture = textureLoader.load("/textures/normal.jpg");
                    normalMapTexture.wrapS = THREE.RepeatWrapping;
                    normalMapTexture.wrapT = THREE.RepeatWrapping;
                    normalMapTexture.repeat.set(3, 3);

                    fpsLowered=true;
                    if(functionFPS){
                        functionFPS(true);
                    }

                    scene.getObjectByName("BODY").material = new THREE.MeshStandardMaterial( {
                        color:  scene.getObjectByName("BODY").material.color,
                        metalness: 0.45,
                        roughness: 0.15,
                        ior: 0.5,
                        thickness:  1,
                        envMap: hdrEquirect,
                        envMapIntensity: 1,
                        transmission: 1, // use material.transmission for glass materials
                        specularIntensity: 1,
                        specularColor: 0xffffff,
                        opacity: 0.9,
                        side: THREE.DoubleSide,
                        transparent: true,
                        //  normalScale: new THREE.Vector2(0.2),
                        bumpMap: scene.getObjectByName("BODY").material.bumpMap,
                        bumpMapScale: 1,
                        //      displacementMap: scene.getObjectByName("BODY").material.displacementMap,
                        //    displacementScale:1,
                        clearcoatNormalMap: normalMapTexture,
                        clearcoatNormalScale: new THREE.Vector2(0.1),
                    } );

                    scene.getObjectByName("BODY").renderOrder= 10;
                    scene.getObjectByName("BODY").material.renderOrder=2;


                    scene.getObjectByName("BODY").material.needsUpdate = true;

                }

            }
        }
        frames = 0;
        prevTime = time;

    }

    //

    //   renderer.render( scene, camera );

}
export function init(typePlugin,returningFunction, packageType, functionsFPSInner) {
    container = document.querySelector('#scene-container');
    THREE.Cache.enabled = true;
    if(typePlugin) {
        isPlugin = true;
    }
    functionFPS=functionsFPSInner;
    const r = "/textures/refraction_hdr/studio/";

    const urls = [
        r + "px.png", r + "nx.png",
        r + "py.png", r + "ny.png",
        r + "pz.png", r + "nz.png"
    ];

    const textureCubeXX = new THREE.CubeTextureLoader().load(urls, function (newMap) {
            newMap.mapping = THREE.CubeRefractionMapping;
            //  newMap.colorSpace = THREE.SRGBColorSpace;
            envMap = newMap;

        if(scene && scene.getObjectByName("BODY")){

            scene.getObjectByName("BODY").material.envMap = envMap;
            scene.getObjectByName("BODY").material.needsUpdate = true;
            scene.getObjectByName("BODY").needsUpdate = true;
        }
        }
    );

    document.addEventListener('mousemove', onDocumentMouseMove);
    document.addEventListener("visibilitychange", function() {
        if (document.visibilityState === "visible") {

           if(activeCamera.position.y < 1 ){
               setUpRulers(false, null, packageTypeGlobal);
           }

        }
    });



    const textureLoader = new THREE.TextureLoader();


    if(typePlugin){
        typePluginInner = true;
    }
    decalMap = textureLoader.load( '/textures/decal-diffuse2.png' );

    if(scene !== undefined){

if(typePlugin && returningFunction){


    scene.clear();
    setUpRenderer(packageType);
    setUpLights(packageType);
    loadEnviroment('default');
    returningFunction();
}
        if(typePlugin && !returningFunction){

            scene.clear();

            window.onresize= null;
            window.onresize = function () {

                if(typePlugin){
                  camera.aspect = container.clientWidth / container.clientHeight;
                    camera.updateProjectionMatrix();

                    renderer.setSize( container.clientWidth , container.clientHeight );
                } else{
                    camera.aspect = window.innerWidth / window.innerHeight;
                    camera.updateProjectionMatrix();

                    renderer.setSize( window.innerWidth, window.innerHeight );
                }


            };

            setUpCamera();

            setUpLights(packageType);
            setUpRenderer(packageType);
            packageTypeGlobal=packageType;
            setUpControls(packageType);
            loadEnviroment('default');

            renderer.setAnimationLoop(() => {

                update();
                render();
            });


        }


   // scene = null;
    } else {

        clearSceneFull();
        scene = new THREE.Scene();
        window.onresize = null;
        window.onresize = function () {

            if(typePlugin){
             camera.aspect = container.clientWidth / container.clientHeight;
                camera.updateProjectionMatrix();

                renderer.setSize( container.clientWidth , container.clientHeight );
            } else{
                camera.aspect = window.innerWidth / window.innerHeight;
                camera.updateProjectionMatrix();

                renderer.setSize( window.innerWidth, window.innerHeight );
            }


        };


        setUpCamera();
        setUpLights(packageType);
        setUpRenderer(packageType);
        packageTypeGlobal=packageType;
        setUpControls(packageType);
        loadEnviroment('default');

        renderer.setAnimationLoop(() => {

            update();
            render();
        });


    }





    setTimeout(function() {
        if (typeof window !== undefined) {
         //   setUPEditUI();
        }

    },150);






    requestAnimationFrame( animate );

}
export function activateComments(){
    //createCommentsDecays();

     setTimeout(function() {
         // makeCommentOnPack();
    }, 100);


}
function setUpRenderer(packageType) {
    // create a WebGLRenderer and set its width and height

    let pixelRatio = window.devicePixelRatio;
    let AA = true;
    if (pixelRatio > 1) {
        AA = false;
    }

    if(renderer !== undefined){

        renderer.forceContextLoss();
        renderer.dispose();
        renderer=undefined;

    }

    if(packageType === "glass-bottles"){
        renderer = new THREE.WebGLRenderer( {
         //   format: THREE.RGBFormat,
            gammaFactor: 0.7,
            powerPreference: "high-performance",
            // antialias: AA,
            antialias:false,
            precision :"lowp",
            autoClear : false,
            alpha:true,
            failIfMajorPerformanceCaveat: true
        } );

        renderer.setClearColor(0x1f1e1c, 1);
    } else {
        renderer = new THREE.WebGLRenderer( {
         //   format: THREE.RGBFormat,
            gammaFactor: 0.7,
            powerPreference: "high-performance",
            antialias: AA,
            precision :"lowp",
            outputColorSpace : THREE.SRGBColorSpace,
            autoClear : false,
            alpha:true,
            failIfMajorPerformanceCaveat: true
        } );

    }


    //
    // @ts-ignore
    renderer.setSize(container.clientWidth, container.clientHeight);
    renderer.setPixelRatio(window.devicePixelRatio);


    renderer.gammaFactor = 2.2;
    // @ts-ignore
    renderer.gammaOutput = true;

    renderer.shadowMap.enabled = true;
    renderer.domElement.setAttribute("data-closemodalmenu","true");


    // @ts-ignore
    container.appendChild(renderer.domElement);

}

const paramsCameraGlobalMaterial = {
    color: 0xffffff,
    metalness: 0.5,
    roughness: 0.5,
    transmission: 1,
    clearcoat:0,
    clearcoatRoughness: 0,
    opacity:1,
    ior:0,
    reflectivity:1,
    transparent: true,
    bumpScale : 1,
    normalScale: 1,
    shininess : 0,
    sheen : 0,
    emmisive: 0,
    cameraX : 0,
    cameraY : 0,
    cameraZ : 0

};
var sceneEditableObjects = ["BODY","BODY_BOTTOM","CAP","CAP_OPENER_HOLE"];
var gui;
// BODY
// CAP


var editableObjectSelected = { Object: 'BODY' };
var editableObjectOrigTex;
var editableObjectOrigBumpTex;
var materialEditableSelected = { material: 'none' };
var sceneSelectableMaterials = [ "MeshBasicMaterial",
    "MeshLambertMaterial","MeshPhongMaterial",
    "MeshPhysicalMaterial", "MeshStandardMaterial"];


var envMapSelected = { envMap: 'none' };
var envMapSelectable = [  "none","1",  "3", "4", "5", "6", "7"];




var sideSelected = { side: 'DoubleSide' };
var sideSelectable = [ "DoubleSide", "FrontSide", "BackSide"];


var combineSelected = { combine: 'THREE.Multiply' };
var combineSelectable = [ "THREE.Multiply", "THREE.MixOperation", "THREE.AddOperation"];
var pauseChanginMat = true;

var setProductVersionInsideRotation;
export var productVersionInsideRotationInner = {};

function setUPEditUI() {
    gui = new guiVar();
    //

    editableObjectOrigTex = scene.getObjectByName(editableObjectSelected.Object).material.map;
    editableObjectOrigBumpTex = scene.getObjectByName(editableObjectSelected.Object).material.bumpMap;
        const statesFolder = gui.addFolder( 'Object Editor' );

        const clipCtrl = statesFolder.add( editableObjectSelected, 'Object' ).options( sceneEditableObjects );

        clipCtrl.onChange( function (e) {
            editableObjectOrigTex = scene.getObjectByName(editableObjectSelected.Object).material.map;
            editableObjectOrigBumpTex = scene.getObjectByName(editableObjectSelected.Object).material.bumpMap;
        } );


        statesFolder.open();

        var ObjectPropFolder = gui.addFolder( 'ObjectPropFolder' );

        var alphaMapCtrl;
        var bumpMapCtrl;
        var emmisiveMapCtrl;
        var lightMapCtrl;
        var envMapCtrl;
        var metalnessMapCtrl;
        var normalMapCtrl;
        var roughnessMapCtrl;
        var sideCtrl;
        var transparentCtrl;
        var colorCtrl;
        var combineCtrl ;
        var reflectivityCtrl;

        var bumpScaleCtrl;
        var normalScaleCtrl ;
        var shininessCtrl;
        var iorCtrl;
        var sheenCtrl;
        var transmissionCtrl ;
        var metalnessCtrl ;
        var roughnessCtrl;
        var emissiveCtrl ;
        var opacityCtrl;


        ObjectPropFolder.open();

        var materialCtrl = statesFolder.add( materialEditableSelected, 'material' ).options( sceneSelectableMaterials );


        materialCtrl.onChange( function (e) {
            /// REMOVE ALL ATTRIBUTES
            if(opacityCtrl !== undefined && opacityCtrl !== null){
                ObjectPropFolder.remove(opacityCtrl);
                opacityCtrl = null;
            }
            if(emissiveCtrl !== undefined && emissiveCtrl !== null){
                ObjectPropFolder.remove(emissiveCtrl);
                emissiveCtrl = null;
            }
            if(alphaMapCtrl !== undefined && alphaMapCtrl !== null){
                ObjectPropFolder.remove(alphaMapCtrl);
                alphaMapCtrl = null;
            }
            if(bumpMapCtrl !== undefined && bumpMapCtrl !== null){
                ObjectPropFolder.remove(bumpMapCtrl);
                bumpMapCtrl = null;
            }
            if(emmisiveMapCtrl !== undefined && emmisiveMapCtrl !== null){
                ObjectPropFolder.remove(emmisiveMapCtrl);
                emmisiveMapCtrl = null;
            }
            if(lightMapCtrl !== undefined && lightMapCtrl !== null){
                ObjectPropFolder.remove(lightMapCtrl);
                lightMapCtrl = null;
            }
            if(envMapCtrl !== undefined && envMapCtrl !== null){
                ObjectPropFolder.remove(envMapCtrl);
                envMapCtrl = null;
            }
            if(metalnessMapCtrl !== undefined && metalnessMapCtrl !== null){
                ObjectPropFolder.remove(metalnessMapCtrl);
                metalnessMapCtrl = null;
            }
            if(normalMapCtrl !== undefined && normalMapCtrl !== null){
                ObjectPropFolder.remove(normalMapCtrl);
                normalMapCtrl = null;
            }
            if(roughnessMapCtrl !== undefined && roughnessMapCtrl !== null){
                ObjectPropFolder.remove(roughnessMapCtrl);
                roughnessMapCtrl = null;
            }
            if(sideCtrl !== undefined && sideCtrl !== null){
                ObjectPropFolder.remove(sideCtrl);
                sideCtrl = null;
            }
            if(transparentCtrl !== undefined && transparentCtrl !== null){
                ObjectPropFolder.remove(transparentCtrl);
                transparentCtrl = null;
            }
            if(colorCtrl !== undefined && colorCtrl !== null){
                ObjectPropFolder.remove(colorCtrl);
                colorCtrl = null;
            }
            if(combineCtrl !== undefined && combineCtrl !== null){
                ObjectPropFolder.remove(combineCtrl);
                combineCtrl = null;
            }
            if(reflectivityCtrl !== undefined && reflectivityCtrl !== null){
                ObjectPropFolder.remove(reflectivityCtrl);
                reflectivityCtrl = null;
            }

            if(bumpScaleCtrl !== undefined && bumpScaleCtrl !== null){
                ObjectPropFolder.remove(bumpScaleCtrl);
                bumpScaleCtrl = null;
            }
            if(normalScaleCtrl !== undefined && normalScaleCtrl !== null){
                ObjectPropFolder.remove(normalScaleCtrl);
                normalScaleCtrl = null;
            }
            if(shininessCtrl !== undefined && shininessCtrl !== null){
                ObjectPropFolder.remove(shininessCtrl);
                shininessCtrl = null;
            }
            if(iorCtrl !== undefined && iorCtrl !== null){
                ObjectPropFolder.remove(iorCtrl);
                iorCtrl = null;
            }
            if(sheenCtrl !== undefined && sheenCtrl !== null){
                ObjectPropFolder.remove(sheenCtrl);
                sheenCtrl = null;
            }

            if(transmissionCtrl !== undefined && transmissionCtrl !== null){
                ObjectPropFolder.remove(transmissionCtrl);
                transmissionCtrl = null;
            }
            if(metalnessCtrl !== undefined && metalnessCtrl !== null){
                ObjectPropFolder.remove(metalnessCtrl);
                metalnessCtrl = null;
            }
            if(roughnessCtrl !== undefined && roughnessCtrl !== null){
                ObjectPropFolder.remove(roughnessCtrl);
                roughnessCtrl = null;
            }


            if(e === "MeshBasicMaterial"){
                transparentCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'transparent', true, false,false );
                opacityCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'opacity', 0, 1,0.05 );
                bumpScaleCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'bumpScale', 0, 1,0.05 );


                sideCtrl = ObjectPropFolder.add( sideSelected, 'side' ).options( sideSelectable );
                sideCtrl.onChange( function (e) {

                } );

                colorCtrl = ObjectPropFolder.addColor( paramsCameraGlobalMaterial, 'color' ).onChange( function ( val ) {
                    //	spotLight.color.setHex( val );
                    //	render();
                } );
                combineCtrl = ObjectPropFolder.add( combineSelected, 'combine' ).options( combineSelectable );
                combineCtrl.onChange( function (e) {
                } );
                envMapCtrl = ObjectPropFolder.add( envMapSelected, 'envMap' ).options( envMapSelectable );
                envMapCtrl.onChange( function (e) {


                } );
                reflectivityCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'reflectivity', 0, 1,0.05 );



                var ChangeMatObj = scene.getObjectByName(editableObjectSelected.Object);
                var originalMap = ChangeMatObj.material.map;
                ChangeMatObj.material = new THREE.MeshBasicMaterial(paramsCameraGlobalMaterial);
                ChangeMatObj.material.map = originalMap;
                ChangeMatObj.material.needUpdate = true;


            }
            if(e === "MeshLambertMaterial"){
                transparentCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'transparent', true, false,false );
                opacityCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'opacity', 0, 1,0.05 );
                //	ObjectPropFolder.remove(1);
                // alphaMapCtrl = ObjectPropFolder.add( alphaMapSelected, 'alphaMap' ).options( alphaMapSelectable );
                // alphaMapCtrl.onChange( function (e) {
                // } );
                bumpScaleCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'bumpScale', 0, 1,0.05 );
                colorCtrl = ObjectPropFolder.addColor( paramsCameraGlobalMaterial, 'color' ).onChange( function ( val ) {
                    //	spotLight.color.setHex( val );
                    //	render();
                } );
                combineCtrl = ObjectPropFolder.add( combineSelected, 'combine' ).options( combineSelectable );
                combineCtrl.onChange( function (e) {
                } );
                envMapCtrl = ObjectPropFolder.add( envMapSelected, 'envMap' ).options( envMapSelectable );
                envMapCtrl.onChange( function (e) {
                } );
                reflectivityCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'reflectivity', 0, 1,0.05 );
               // refractionRatioCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'refractionRatio', 0, 1,0.05 );
                emissiveCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'emmisive', 0, 1,0.05 );


                var ChangeMatObj = scene.getObjectByName(editableObjectSelected.Object);
                var originalMap = ChangeMatObj.material.map;
                ChangeMatObj.material = new THREE.MeshLambertMaterial(paramsCameraGlobalMaterial);
                ChangeMatObj.material.map = originalMap;
                ChangeMatObj.material.needUpdate = true;



            }

            if(e === "MeshNormalMaterial"){

                sideCtrl = ObjectPropFolder.add( sideSelected, 'side' ).options( sideSelectable );
                sideCtrl.onChange( function (e) {

                } );
                opacityCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'opacity', 0, 1,0.05 );
                colorCtrl = ObjectPropFolder.addColor( paramsCameraGlobalMaterial, 'color' ).onChange( function ( val ) {
                    //	spotLight.color.setHex( val );
                    //	render();
                } );
                bumpScaleCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'bumpScale', 0, 1,0.05 );
                //
                // bumpMapCtrl = ObjectPropFolder.add( bumpMapSelected, 'bumpMap' ).options( bumpMapSelectable );
                // bumpMapCtrl.onChange( function (e) {
                // } );
                // bumpScaleCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'bumpScale', 0, 1,0.05 );
                transparentCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'transparent', true, false,false );

                var ChangeMatObj = scene.getObjectByName(editableObjectSelected.Object);
                var originalMap = ChangeMatObj.material.map;
                ChangeMatObj.material = new THREE.MeshNormalMaterial(paramsCameraGlobalMaterial);
                ChangeMatObj.material.map = originalMap;
                ChangeMatObj.material.needUpdate = true;



            }
            if(e === "MeshPhongMaterial"){
                transparentCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'transparent', true, false,false );
                opacityCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'opacity', 0, 1,0.05 );
                // alphaMapCtrl = ObjectPropFolder.add( alphaMapSelected, 'alphaMap' ).options( alphaMapSelectable );
                // alphaMapCtrl.onChange( function (e) {
                // } );
                // bumpMapCtrl = ObjectPropFolder.add( bumpMapSelected, 'bumpMap' ).options( bumpMapSelectable );
                // bumpMapCtrl.onChange( function (e) {
                // } );
                // bumpScaleCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'bumpScale', 0, 1,0.05 );
                bumpScaleCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'bumpScale', 0, 1,0.05 );
                sideCtrl = ObjectPropFolder.add( sideSelected, 'side' ).options( sideSelectable );
                sideCtrl.onChange( function (e) {

                } );

                colorCtrl = ObjectPropFolder.addColor( paramsCameraGlobalMaterial, 'color' ).onChange( function ( val ) {
                    //	spotLight.color.setHex( val );
                    //	render();
                } );
                combineCtrl = ObjectPropFolder.add( combineSelected, 'combine' ).options( combineSelectable );
                combineCtrl.onChange( function (e) {
                } );
                emissiveCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'emmisive', 0, 1,0.05 );
                envMapCtrl = ObjectPropFolder.add( envMapSelected, 'envMap' ).options( envMapSelectable );
                envMapCtrl.onChange( function (e) {
                } );
                reflectivityCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'reflectivity', 0, 1,0.05 );
            //    refractionRatioCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'refractionRatio', -1, 1,0.05 );
                shininessCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'shininess', 0, 1,0.05 );

                var ChangeMatObj = scene.getObjectByName(editableObjectSelected.Object);
                var originalMap = ChangeMatObj.material.map;
                ChangeMatObj.material = new THREE.MeshPhongMaterial(paramsCameraGlobalMaterial);
                ChangeMatObj.material.map = originalMap;
                ChangeMatObj.material.needUpdate = true;

            }
            if(e === "MeshPhysicalMaterial"){

                transparentCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'transparent', true, false,false );
                opacityCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'opacity', 0, 1,0.05 );
                bumpScaleCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'bumpScale', 0, 1,0.05 );
                sheenCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'sheen', 0, 1,0.05 );
                // transmissionCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'transmission', 0, 1,0.05 );

                reflectivityCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'reflectivity', 0, 1,0.05 );
                iorCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'ior', 0, 1,0.05 );



                sideCtrl = ObjectPropFolder.add( sideSelected, 'side' ).options( sideSelectable );
                sideCtrl.onChange( function (e) {

                } );
                colorCtrl = ObjectPropFolder.addColor( paramsCameraGlobalMaterial, 'color' ).onChange( function ( val ) {
                    //	spotLight.color.setHex( val );
                    //	render();
                } );

                emissiveCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'emmisive', 0, 1,0.05 );
                envMapCtrl = ObjectPropFolder.add( envMapSelected, 'envMap' ).options( envMapSelectable );
                envMapCtrl.onChange( function (e) {
                } );


                metalnessCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'metalness', 0, 1,0.05 );
                roughnessCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'roughness', 0, 1,0.05 );

           //     refractionRatioCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'refractionRatio', 0, 1,0.05 );

                var ChangeMatObj = scene.getObjectByName(editableObjectSelected.Object);
                var originalMap = ChangeMatObj.material.map;
                ChangeMatObj.material = new THREE.MeshPhysicalMaterial(paramsCameraGlobalMaterial);
                ChangeMatObj.material.map = originalMap;
                ChangeMatObj.material.needUpdate = true;

            }
            if(e === "MeshStandardMaterial"){
                transparentCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'transparent', true, false,false );
                opacityCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'opacity', 0, 1,0.05 );

                bumpScaleCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'bumpScale', 0, 1,0.05 );
                sideCtrl = ObjectPropFolder.add( sideSelected, 'side' ).options( sideSelectable );
                sideCtrl.onChange( function (e) {

                } );
                colorCtrl = ObjectPropFolder.addColor( paramsCameraGlobalMaterial, 'color' ).onChange( function ( val ) {

                    //	spotLight.color.setHex( val );
                    //	render();
                } );

                emissiveCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'emmisive', 0, 1,0.05 );
                envMapCtrl = ObjectPropFolder.add( envMapSelected, 'envMap' ).options( envMapSelectable );
                envMapCtrl.onChange( function (e) {
                } );




                metalnessCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'metalness', 0, 1,0.05 );
                roughnessCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'roughness', 0, 1,0.05 );

          //      refractionRatioCtrl = ObjectPropFolder.add( paramsCameraGlobalMaterial, 'refractionRatio', 0, 1,0.05 );
                var ChangeMatObj = scene.getObjectByName(editableObjectSelected.Object);
                var originalMap = ChangeMatObj.material.map;
                ChangeMatObj.material = new THREE.MeshStandardMaterial(paramsCameraGlobalMaterial);
                ChangeMatObj.material.map = originalMap;
                ChangeMatObj.material.needUpdate = true;

                //
            }

            pauseChanginMat = false;

        } );

        gui.open();

    }



function setUpCamera() {
    // @ts-ignore

    camera = new THREE.PerspectiveCamera(50, container.clientWidth / container.clientHeight, 1, 120);
    camera.position.set(0, 20, -25);

    camera2 = new THREE.OrthographicCamera( 400 / - 2, 400 / 2, 600 / 2, 600 / - 2, 0.001, 800 );
    camera2.zoom = 30;
    camera2.position.set(0, 0, -10);
    camera2.updateProjectionMatrix();

    activeCamera = camera;


}

let rotationEnabled = false;
const autoRotateSpeed = 0.01; // upravte podle potřeby (v radiánech na frame)

export function rotateProduct() {
    // Přepnutí stavu auto-rotace
    rotationEnabled = !rotationEnabled;
}
//
// var rotationEnabled = false;
// export function rotateProduct(){
//
//     if(!rotationEnabled){
//         controls.autoRotate = true;
//         controls.autoRotateSpeed = 5.0;
//         rotationEnabled = true;
//     } else{
//         controls.autoRotate = false;
//
//         rotationEnabled = false;
//     }
//
//     controls.update();
// }
let minDistancePinch =0;
let maxDistancePinch = 0;
let currentDistancePinch=0;
let targetPinch = new THREE.Vector3(0,0, 0);
let baseRotationY = Math.PI;
function setUpControls(packageType) {

    console.log("IS PLUGIN ", isPlugin);

    if(isPlugin){

        scene.rotation.y = Math.PI;
        // Proměnné pro uchování stavu ovládání
        let isPanning = false;
        let lastDeltaX = 0;
        let lastDeltaY = 0;
        console.log("Hammer1");

        let hammerInstance;
        import('hammerjs')
            .then((HammerModule) => {
                // Některé verze exportují jako default, proto:
                const Hammer = HammerModule.default || HammerModule;
                hammerInstance = new Hammer(window);
                // Nastavíme rozpoznávání pan gesta ve všech směrech
                hammerInstance.get('pan').set({ direction: Hammer.DIRECTION_ALL });

                hammerInstance.on('panstart', (ev) => {
                    isPanning = true;
                    lastDeltaX = ev.deltaX;
                    lastDeltaY = ev.deltaY;

                    baseRotationY = scene.rotation.y;
                    console.log("panstart", baseRotationY);
                    console.log("panstart");
                });


                hammerInstance.on('panmove', (ev) => {
                    if (!isPanning) return;
                    // Vypočítáme změnu od posledního eventu
                    const deltaX = ev.deltaX - lastDeltaX;
                    const deltaY = ev.deltaY - lastDeltaY;
                    lastDeltaX = ev.deltaX;
                    lastDeltaY = ev.deltaY;
                    console.log("panmove",lastDeltaY, lastDeltaX);
                    // Aktualizujeme rotaci kamery – nastavíme změnu kolem osy Y (horizontálně) a osy X (vertikálně)
                    // Přičemž násobíme malým faktorem (např. 0.005) pro jemnější ovládání.
                 //   scene.rotation.y += deltaX * 0.005;
                 //   scene.rotation.y = Math.PI + (ev.deltaX * 0.005);

                    scene.rotation.y =  baseRotationY + (ev.deltaX * 0.005);
                    console.log("panmove", scene.rotation.y);

                   // camera.rotation.x += deltaY * 0.005;

                    // controls.minPolarAngle = Math.PI / -1;
                 //   var maximumAngleCamera = AppConfig.editor_settings.maximumAngleCamera;

                      //  controls.maxPolarAngle = Math.PI / AppConfig.editor_settings.maximumAngleCamera;
                 //    const maxRotationX =  Math.PI / AppConfig.editor_settings.maximumAngleCamera;
                   //  const minRotationX = Math.PI / -1;

                    // Volitelně můžete omezit rotaci kamery, aby nedošlo k překlápění.
                  //  const maxRotationX = Math.PI / 2 - 0.1;
                   // const minRotationX = -Math.PI / 2 + 0.1;
                   // scene.rotation.x = Math.max(Math.min(scene.rotation.x, maxRotationX), minRotationX);

                    const newRotationX = scene.rotation.x + deltaY * 0.005;
                    // Omezení rotace kolem X, aby nedošlo k překlápění
                    const maxRotationX = Math.PI / AppConfig.editor_settings.maximumAngleCamera;
                    const minRotationX = -Math.PI / 2 + 1.35;
                    scene.rotation.x = Math.max(Math.min(newRotationX, maxRotationX), minRotationX);

                });

                hammerInstance.on('panend', () => {
                    isPanning = false;
                    console.log("panend",lastDeltaY, lastDeltaX);
                });


            })
            .catch((err) => console.error('Error loading Hammer.js:', err));
    } else {


if(controls){
    controls.removeEventListener( 'change', render );
    controls.dispose();
    controls =null;
}

    controls = new OrbitControls( camera, renderer.domElement );

    controls.addEventListener( 'change', render );


    controls.minDistance = 18;
    controls.maxDistance = 40;
    //controls.dista
    controls.enableDamping = true; // an animation loop is required when either damping or auto-rotation are enabled
    controls.dampingFactor = 0.1;
    controls.enabled = true;
    controls.screenSpacePanning = false;
    controls.update();
    controls.autoRotate = false;
  //  controls.dIn(1.05);
    //   const controls = new THREE.OrbitControls(camera, renderer.domElement)
   // controls.rotateSpeed = 2.0;
    controls.zoomSpeed = 0.5;
   // controls.panSpeed = 2;
    controls.enableZoom = true;
  //  controls.rotate


    controls.enablePan = false;
    controls.update();
   // controls.reset();
    //controls.zoom = 20;
    // controls.rotate( 90 * Math.PI / 180 );

     controls.minPolarAngle = Math.PI / -1;
var maximumAngleCamera = AppConfig.editor_settings.maximumAngleCamera;

    if(packageType !== "shrinks"){
        controls.maxPolarAngle = Math.PI / 1.9;
    }
    // AppConfig1.7


    if(fullHeightTotal){
        controls.target.set(0, fullHeightTotal/2, 0);

        controls.minDistance = fullHeightTotal;
        controls.maxDistance = fullHeightTotal*3;

    } else {
        controls.target.set(0, 8, 0);
    }

    controls.update();

    }
}

export function setCameraView(view: string | undefined) {


    controls.update();
    controlsAllowed = false;

    if (view == 'BODY') {
        if(TWEEN !== undefined){
            new TWEEN.Tween(camera.position).to({
                x: 0,
                z: 5,
                y: -25
            }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
        }

    }
    if (view == 'CAP') {
        // Shell
        if(TWEEN !== undefined){
            new TWEEN.Tween(camera.position).to({
                x: 0,
                z: 3,
                y: 25
            }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
        }

    }
    if (view == 'CAP_OPENER_HOLE') {
        // Tab

    }

    setTimeout(function() {
        controlsAllowed = true;
    },300);
}

export function setUpLights(packageType) {

    if(packageType !== "glass-bottles" ){
        const ambientLight = new THREE.HemisphereLight(0xffffff, 0xffffff, 2.7);

        scene.add(ambientLight);
        //


        const light = new THREE.DirectionalLight( 0xFFFFFF,0.4);
        scene.add( light );
        light.name="light15_1";
        light.position.set(20, 25, 0);

        const light2 = new THREE.DirectionalLight( 0xFFFFFF,0.4);
        scene.add( light2 );
        light2.name="light15_2";
        light2.position.set(-20, 25, 0);

        //
        //
        const light3 = new THREE.DirectionalLight( 0xFFFFFF,0.4);
        scene.add( light3 );
        light3.name="light15_3";
        light3.position.set(0, 25, -20);
        //
        const light4 = new THREE.DirectionalLight( 0xFFFFFF,0.4);
        scene.add( light4 );
        light4.name="light15_4";
        light4.position.set(0, 25, 20);


        const light2down = new THREE.DirectionalLight( 0xFFFFFF,0.2);
        scene.add( light2down );
        light2down.name="light07_2";
        light2down.position.set(-20, 3, 0);
        //
        //
        //
        const light3down = new THREE.DirectionalLight( 0xFFFFFF,0.2);
        scene.add( light3down );
        light3down.name="light07_3";
        light3down.position.set(0, 3, -20);

        const light4down = new THREE.DirectionalLight( 0xFFFFFF,0.2);
        scene.add( light4down );
        light4down.name="light07_4";
        light4down.position.set(0, 3, 20);
    } else {
        const ambientLight = new THREE.HemisphereLight(0xffffff, 0xffffff, 1);

        scene.add(ambientLight);
    }

}

export function cleanSceneBeforeReload(returnFunction) {
    scene.clear();

    // clean up
}

export function cleanUpMemory() {
    if (scene !== undefined) {
        if (scene.traverseVisible !== undefined) {
            if (scene !== undefined) {
                scene.traverseVisible(function(child) {
                    if (child.type !== 'Scene') {
                        scene.remove(child);
                    }
                });
            }
        }

    }

    // clean up
}
var controlsAllowed = true;
function update() {
    const delta = clock.getDelta();
    if(TWEEN !== undefined){
        TWEEN.update();
    }

    if(controls){
        controls.update();
    }

}

var setAngleRotation = undefined;

export function render() {
    if(scene.getObjectByName(editableObjectSelected.Object) !== "none" && !pauseChanginMat ){
        var ChangeMatObj = scene.getObjectByName(editableObjectSelected.Object);
        if(paramsCameraGlobalMaterial.color !== undefined && ChangeMatObj.material.color !== undefined){
            ChangeMatObj.material.color.setHex(paramsCameraGlobalMaterial.color );
        }
        ChangeMatObj.material.metalness = paramsCameraGlobalMaterial.metalness;
        ChangeMatObj.material.roughness = paramsCameraGlobalMaterial.roughness;
        // ChangeMatObj.material.transmission = paramsCameraGlobalMaterial.transmission;
        ChangeMatObj.material.clearcoat = paramsCameraGlobalMaterial.clearcoat;
        ChangeMatObj.material.clearcoatRoughness = paramsCameraGlobalMaterial.clearcoat;
        ChangeMatObj.material.opacity = paramsCameraGlobalMaterial.opacity;
        ChangeMatObj.material.ior = paramsCameraGlobalMaterial.ior;
     //   ChangeMatObj.material.refractionRatio = paramsCameraGlobalMaterial.refractionRatio;
        ChangeMatObj.material.reflectivity = paramsCameraGlobalMaterial.reflectivity;
        ChangeMatObj.material.transparent = paramsCameraGlobalMaterial.transparent;
        ChangeMatObj.material.bumpScale = paramsCameraGlobalMaterial.bumpScale;
        ChangeMatObj.material.normalScale = paramsCameraGlobalMaterial.normalScale;
        ChangeMatObj.material.shininess  = paramsCameraGlobalMaterial.shininess;
            ChangeMatObj.material.sheen  = paramsCameraGlobalMaterial.sheen;
        ChangeMatObj.material.emmisive = paramsCameraGlobalMaterial.emmisive;
        ChangeMatObj.material.map = editableObjectOrigTex;
        ChangeMatObj.material.envMap = envMap;
        if(editableObjectOrigBumpTex !== null && editableObjectOrigBumpTex !== undefined){
            ChangeMatObj.material.bumpMap = editableObjectOrigBumpTex;
        }

        ChangeMatObj.material.needUpdate = true;
    }

    //rotateAroundWorldAxis("BODY", new THREE.Vector3(1, 0, 0), mouseX);
    renderer.render(scene, activeCamera);

    if((scene.getObjectByName("Scene") || scene.getObjectByName("BodyModelScene")|| scene.getObjectByName("BODY"))  && rotationSetActive){
        targetX = mouseX * .01;

        if(typeOfRotation === "BODY"){


        } else if(typeOfRotation === "can1"){

           scene.getObjectByName("BODY_CAN_500_1").rotation.y = (Math.PI / 180) * mouseX;
            productVersionInsideRotationInner["1"] =  mouseX;

        }else if(typeOfRotation === "can2"){
            scene.getObjectByName("BODY_CAN_500_2").rotation.y = (Math.PI / 180) * mouseX;
            productVersionInsideRotationInner["2"] =  mouseX;
        }
        else if(typeOfRotation === "can3"){
            scene.getObjectByName("BODY_CAN_500_3").rotation.y = (Math.PI / 180) * mouseX;
            productVersionInsideRotationInner["3"] =  mouseX;
        }
        else if(typeOfRotation === "can4"){
            scene.getObjectByName("BODY_CAN_500_4").rotation.y = (Math.PI / 180) * mouseX;
            productVersionInsideRotationInner["4"] =   mouseX;
        }
        else if(typeOfRotation === "can5"){
            scene.getObjectByName("BODY_CAN_500_5").rotation.y = (Math.PI / 180) * mouseX;
            productVersionInsideRotationInner["5"] =  mouseX;
        }
        else if(typeOfRotation === "can6"){
            scene.getObjectByName("BODY_CAN_500_6").rotation.y = (Math.PI / 180) * mouseX;
            productVersionInsideRotationInner["6"] =  mouseX;
        }
        else if(typeOfRotation === "can7"){
            scene.getObjectByName("BODY_CAN_500_7").rotation.y = (Math.PI / 180) * mouseX;
            productVersionInsideRotationInner["7"] = mouseX;
        }
        else if(typeOfRotation === "can8"){
            scene.getObjectByName("BODY_CAN_500_8").rotation.y = (Math.PI / 180) * mouseX;
            productVersionInsideRotationInner["8"] =  mouseX;
        }
        else if(typeOfRotation === "can9"){
            scene.getObjectByName("BODY_CAN_500_9").rotation.y = (Math.PI / 180) * mouseX;
            productVersionInsideRotationInner["9"] =  mouseX;
        }
        else if(typeOfRotation === "can10"){
            scene.getObjectByName("BODY_CAN_500_10").rotation.y = (Math.PI / 180) * mouseX;
            productVersionInsideRotationInner["10"] =  mouseX;
        }
        else if(typeOfRotation === "can11"){
            scene.getObjectByName("BODY_CAN_500_11").rotation.y = (Math.PI / 180) * mouseX;
            productVersionInsideRotationInner["11"] =  mouseX;
        }
        else if(typeOfRotation === "can12"){
            scene.getObjectByName("BODY_CAN_500_12").rotation.y = (Math.PI / 180) * mouseX;
            productVersionInsideRotationInner["12"] = mouseX;
        }



        if(scene.getObjectByName("OpeningGroup")){
           scene.getObjectByName("OpeningGroup").rotation.y = (Math.PI / 180) * mouseX;
       }




    }




}




export function onWindowResize() {
    camera.aspect = container.clientWidth / container.clientHeight;

    camera.updateProjectionMatrix();

    renderer.setSize(container.clientWidth, container.clientHeight);
}


///////////////////////////////////////////////////////////////////////////////////// INIT

///////////////////////////////////////////////////////////////////////////////////// COMMENTS
var moved = false;


export function createCommentsDecays() {
    var geometry = new THREE.BufferGeometry(1,1);
    geometry.setFromPoints([new THREE.Vector3(), new THREE.Vector3()]);
    line = new THREE.Line(geometry, new THREE.LineBasicMaterial());
    line.name= "commentLine";
    scene.add(line);


    raycaster = new THREE.Raycaster();
    mouseHelper = new THREE.Mesh(new THREE.BoxGeometry(2, 2, 1), new THREE.MeshNormalMaterial());
    mouseHelper.visible = false;
    mouseHelper.name="commentMouseHelper"
    scene.add(mouseHelper);



    var positionsCommentClick = [];

  //  controls.addEventListener('change', controlsChangeCommentEv);

    window.addEventListener(
        'mousedown',mouseDownCommentEv,  false,
    );

    window.addEventListener('mouseup', mouseUpCommentEv);

    window.addEventListener('mousemove', onTouchMove);
    window.addEventListener('touchmove', onTouchMove);

}
function controlsChangeCommentEv(){
    moved = true;
}

function mouseDownCommentEv(){
    moved = false;
}

function mouseUpCommentEv(){

    checkIntersection();
    if (!moved && intersection.intersects) makeCommentOnPack();
}
function onTouchMove(event: any) {
    var x, y;

    if (event.changedTouches) {
        x = event.changedTouches[0].pageX;
        y = event.changedTouches[0].pageY;
    } else {
        x = event.clientX;
        y = event.clientY;
    }

    mouse.x = (x / window.innerWidth) * 2 - 1;
    mouse.y = -(y / window.innerHeight) * 2 + 1;

    checkIntersection();
}

function checkIntersection() {

    if (!mesh) return;

    raycaster.setFromCamera(mouse, camera);
    raycaster.intersectObject(mesh, false, intersects);

    if (intersects.length > 0) {
        var p = intersects[0].point;
        mouseHelper.position.copy(p);
        intersection.point.copy(p);

        var n = intersects[0].face.normal.clone();
        n.transformDirection(mesh.matrixWorld);
        n.multiplyScalar(10);
        n.add(intersects[0].point);

        intersection.normal.copy(intersects[0].face.normal);
        mouseHelper.lookAt(n);

        var positions = line.geometry.attributes.position;
        positions.setXYZ(0, p.x, p.y, p.z);
        positions.setXYZ(1, n.x, n.y, n.z);
        positions.needsUpdate = true;


        intersection.intersects = true;

        intersects.length = 0;

    } else {
        intersection.intersects = false;
    }
}

export function makeCommentOnPack(newPoints, newCallback, number, color) {

    if(newPoints){
        var xNef = newPoints.x;
        var yNef = newPoints.y;
        var zNef = newPoints.z;
        if(newCallback){
            newCallback(decalsNumber.length + 1);
        }

        position.x = xNef;
        position.y = yNef;
        position.z = zNef;
        orientation.set(0,0,0);
    } else {
        orientation.copy(mouseHelper.rotation);
        position.copy(intersection.point);
    }

    size.set(0.5, 0.5, 0.5);



    var material = decalMaterial.clone();
    material.map = decalMap;
console.log("COLOR COMMENT ", color);
    if(color){
        material.color.setHex( color);
    } else {
        material.color.setHex( 0xC80000);
    }

    material.opacity= 1;
    material.transparent= true;
    material.needsUpdate = true;

    // -----------------------------

    const geometry = new THREE.SphereGeometry( 0.2, 32, 16 );

    let material2;
    if(color){
         material2 = new THREE.MeshBasicMaterial( { color: color,transparent:true } );
    } else {
         material2 = new THREE.MeshBasicMaterial( { color: 0xC80000,transparent:true } );
    }

    const sphere = new THREE.Mesh( geometry, material2 );
    sphere.position.set( position.x, position.y, position.z );
    sphere.name = "comment"+(number ? number : decalsNumber.length + 1);
    // sphere.renderOrder=100;
    // sphere.material.renderOrder=100;
    // sphere.material.needsUpdate=true;
    scene.add( sphere );




  //  const geometry = new THREE.CylinderGeometry( 0, 0.05, 0.2, 32 ).rotateX( Math.PI / 2 );
  //   var m = new THREE.Mesh(new DecalGeometry(mesh, position, orientation, size), material);
  //
  //   m.name = "comment"+(number ? number : decalsNumber.length + 1);

    var offsetX= 0;
    var offsetZ = 0;

    if(position.x < 0 ){
        offsetX = -0.3;
    } else {
        offsetX = 0.3;
    }

    if(position.z < 0 ){
        offsetZ = -0.3;
    } else {
        offsetZ = 0.3;
    }


    let sprite = new TextSprite({
        text:   commentsEnabled ? ((number ? number : decalsNumber.length + 1).toString()) :"",
        fontFamily: 'Arial',
        fontSize: 0.5,
        color: '#fff',
        strokeColor: '#000',
        // backgroundColor:'#fff',
        padding: 0.5,
        alignment:"center",
        strokeWidth: 0.04,
        fontStyle: 'bold',
    });
    sprite.name = "CommentNumber"+(number ? number :  decalsNumber.length + 1);
    sprite.renderOrder=55;
    sprite.material.renderOrder=55;
    sprite.material.needsUpdate=true;
    scene.add(sprite);
    sprite.position.set( position.x + offsetX,position.y, position.z + offsetZ);

    decalsNumber.push(sprite);
    decals.push(sphere);
    scene.add(sphere);


    if(callBackComment){
        callBackComment(position);
    }

}


export function setActiveComment(numberOfComment) {
    if(numberOfComment){
        decals.forEach(function(d) {
            d.material.opacity = 0.1;
            d.material.transparent=true;
            d.material.needsUpdate = true;
        });
        scene.getObjectByName("comment"+numberOfComment).material.opacity = 0.8;
        scene.getObjectByName("comment"+numberOfComment).needsUpdate = true;

    } else {
        decals.forEach(function(d) {
            d.material.opacity = 0.8;
            d.material.transparent=true;
            d.material.needsUpdate = true;
        });
    }

}


export function removeCommentPack(number) {


    for (let i = 0; i < decals.length; i++) {
      if(i === (number)){
          scene.remove(decals[i]);
          decals.splice(i, 1);
      }
    }
    for (let i = 0; i < decalsNumber.length; i++) {
        if(i === (number )){


            scene.remove(decalsNumber[i]);
            decalsNumber.splice(i, 1);

        }
    }

/*
    decals.forEach(function(d) {
        scene.remove(d);
    });

    decals = [];

    decalsNumber.forEach(function(d) {
        scene.remove(d);
    });
*/


}
export function disablecomments(){
    scene.remove(line)
    scene.remove(mouseHelper)

  //  controls.removeEventListener('change');

    controls.removeEventListener('change', controlsChangeCommentEv);

    window.removeEventListener(
        'mousedown',mouseDownCommentEv,
    );

    window.removeEventListener('mouseup', mouseUpCommentEv);

    window.removeEventListener('mousemove', onTouchMove);
    window.removeEventListener('touchmove', onTouchMove);

   // removeDecals();
}
export function removeDecals() {
    decals.forEach(function(d) {
        if(scene){
            scene.remove(d);
        }

    });

    decals = [];

    decalsNumber.forEach(function(d) {
        if(scene){
            scene.remove(d);
        }


    });

    decalsNumber = [];

}
///////////////////////////////////////////////////////////////////////////////////// END COMMENTS
var gridOpacity = 0.1;

///////////////////////////////////////////////////////////////////////////////////// ENVIROMENT
function makeGridMatrix() {
    var planeGeometry = new THREE.PlaneGeometry(50, 50);
    planeGeometry.rotateX(-Math.PI / 2);
    var planeMaterial = new THREE.ShadowMaterial({ opacity: 0.7 });

    var plane = new THREE.Mesh(planeGeometry, planeMaterial);
    plane.position.y = -1;
    plane.receiveShadow = true;
    scene.add(plane);

    var helper = new THREE.GridHelper(100, 100);
    helper.position.y = 0;
    helper.material.color = new THREE.Color(0x000);
    helper.material.opacity = gridOpacity;
    helper.material.transparent = true;
    helper.name = "GridScene";
  //  helper.renderOrder= 2;
    scene.add(helper);
}
function removeGridMatrix(){

    var ObjectLine = scene.getObjectByProperty("type", "Line");
    if( ObjectLine != undefined){
        const parentLine = ObjectLine.parent;
        parentLine.remove( ObjectLine );
    }

    var ObjectLineSegments = scene.getObjectByProperty("type", "LineSegments");

    if( ObjectLineSegments != undefined){
        const parentLineSegments = ObjectLineSegments.parent;
        parentLineSegments.remove( ObjectLineSegments );
    }


}
var fullHeightCamera = 0;
export function loadEnviroment(enviroment: string | undefined) {
    // @ts-ignore
    var pmremGenerator = new THREE.PMREMGenerator(renderer);
    pmremGenerator.compileEquirectangularShader();
    /////////////// LOAD ENVIROMENT

    var enviromentVar = 'gradient1.hdr';

    if (enviroment == 'default') {
        enviromentVar = 'default.jpg';
    }
    if (enviroment == 'bar') {
        enviromentVar = 'bar.hdr';
    }
    if (enviroment == 'kitchen') {
        enviromentVar = 'kitchen.hdr';
    }
    if (enviroment == 'field') {
        enviromentVar = 'field2.hdr';
    }


    removeGridMatrix();



     hdrJpgDefault= new HDRJPGLoader(renderer)
        .load('/textures/enviroment/gradient1.jpg', function () {
            var hdrJpgEquirectangularMap = hdrJpgDefault.renderTarget.texture;
            hdrJpgEquirectangularMap.mapping = THREE.EquirectangularReflectionMapping;
            hdrEquirectDefault = hdrJpgEquirectangularMap;

          //  var envMap = pmremGenerator.fromEquirectangular(texture).texture;
            scene.background = new THREE.Color(0xf0f0f0);
            scene.background = hdrJpgEquirectangularMap;
            scene.environment = hdrJpgEquirectangularMap;

         //   texture.dispose();
            pmremGenerator.dispose();
            render();

            if (enviroment == 'default') {
                makeGridMatrix();
            }
            if (enviroment == 'bar') {
                //   enviromentVar = "field.hdr";
            }
            if (enviroment == 'kitchen') {
                // enviromentVar = "kitchen.hdr";
            }
            if (enviroment == 'field') {
                loadModel('/models/gltf/Stolecky/krabiceENV.gltf');

                //enviromentVar = "field.hdr";
            }


        }, function (progress) {

        });

   /* // @ts-ignore
    new RGBELoader()
        .setDataType(THREE.HalfFloatType)
        .setPath('/textures/enviroment/')
        .load(enviromentVar, function(texture: any) {

            var envMap = pmremGenerator.fromEquirectangular(texture).texture;
            scene.background = new THREE.Color(0xf0f0f0);
            scene.background = envMap;
            scene.environment = envMap;
            texture.dispose();
            pmremGenerator.dispose();
            render();

            if (enviroment == 'default') {
                makeGridMatrix();
            }
            if (enviroment == 'bar') {
                //   enviromentVar = "field.hdr";
            }
            if (enviroment == 'kitchen') {
                // enviromentVar = "kitchen.hdr";
            }
            if (enviroment == 'field') {
                loadModel('/models/gltf/Stolecky/krabiceENV.gltf');

                //enviromentVar = "field.hdr";
            }
        });*/
}
///////////////////////////////////////////////////////////////////////////////////// END ENVIROMENT
let azimuthAngle = 0;      // horizontální rotace
let polarAngle = Math.PI / 2; // vertikální – 90° (kamera v rovině s targetem)
function updateCamera() {
    // Spočítáme pozici kamery podle sférických souřadnic
    const x = targetPinch.x + currentDistancePinch * Math.sin(polarAngle) * Math.sin(azimuthAngle);
    const y = targetPinch.y + currentDistancePinch * Math.cos(polarAngle);
    const z = targetPinch.z + currentDistancePinch * Math.sin(polarAngle) * Math.cos(azimuthAngle);
    camera.position.set(x, y, z );
    camera.lookAt(0,fullHeightCamera/2,0);
}
export function setUpRulers(loadingFromfile, closeLoadingInit, packageType){

if(!loadingFromfile){

    var box;
console.log("TF", scene, scene.getObjectByName("BODY"));
    if(scene.getObjectByName("Package") !== undefined){
        box = new THREE.Box3().setFromObject( scene.getObjectByName("Package"), true );
    } else {

        box = new THREE.Box3().setFromObject( scene.getObjectByName("BODY"), true );
    }


    var sizeBoxBody = box.getSize(new THREE.Vector3());

    var fullHeight = sizeBoxBody.y;
    var fullWidth = sizeBoxBody.x;

if(!isPlugin){
    controls.target.set(0, fullHeight/2, 0);

    controls.minDistance = fullHeight;
    controls.maxDistance = fullHeight*3;
    controls.update();
} else {

    // Nastavíme cílový bod, který chcete mít stejný jako s OrbitControls.target.set(0, fullHeight/2, 0)
    const target = new THREE.Vector3(0, fullHeight / 2, 0);

    targetPinch =target;
    if(fullWidth > 12){
        minDistancePinch = fullHeight * 1.5;
    } else {
        minDistancePinch = fullHeight;
    }

    maxDistancePinch = fullHeight * 3;

    let minDistance = fullHeight;
    let maxDistance = fullHeight * 3;

   //currentDistancePinch = camera.position.distanceTo(targetPinch);
    const initialOffset = new THREE.Vector3().subVectors(camera.position, target);
    const initialDistance = initialOffset.length();

    let currentDistance = fullHeight ; // minDistance = fullHeight, maxDistance = fullHeight * 3
console.log("fullWidth", fullWidth);

        camera.position.set(45, fullHeight/2, -40);
        camera.lookAt(0,fullHeight/2,0);

        fullHeightCamera=fullHeight;
    currentDistance = fullHeight * 2; // minDistance
    currentDistancePinch = currentDistance;
        // if(packageType === "glass-bottles"){
        //     currentDistance = fullHeight * 1.5; // minDistance
        // }



    updateCamera();

    renderer.domElement.addEventListener('wheel', (ev) => {
        ev.preventDefault();
        console.log("WHEEL");
        // ev.deltaY: kladná hodnota = posuv dolů (obvykle zoom out), záporná = zoom in
        // Nastavíme citlivost – například 0.05 (lze upravit dle potřeby)
        currentDistancePinch += ev.deltaY * 0.05;
        // Omezení vzdálenosti
        currentDistancePinch = Math.max(minDistancePinch, Math.min(maxDistancePinch, currentDistancePinch));

        updateCamera();

    });


}


    fullHeightTotal=fullHeight;

    log("SET UP INSIDE ", fullHeightTotal);


    var fullWidth = sizeBoxBody.z;
    const dir = new THREE.Vector3( 0,  1,  0);
    const dirWidth = new THREE.Vector3( 1,  0,  0);
    const dirBack = new THREE.Vector3( 0,  -1,  0);
    const dirWidthBack = new THREE.Vector3( -1,  0,  0);

    dirWidth.normalize();
    dir.normalize();

    const origin = new THREE.Vector3(  sizeBoxBody.x , 0,  0 );
    const length =  fullHeight ;
    const hex = 0x404040;
    const arrowHelper = new THREE.ArrowHelper( dir, origin, length, hex , 1);
    arrowHelper.name = "ArrowHelper1";


    const arrowHelperBack = new THREE.ArrowHelper( dirBack, origin, length, hex , 1);
    arrowHelperBack.name = "ArrowHelper1Back";
    arrowHelperBack.position.set( arrowHelperBack.position.x, fullHeight,  arrowHelperBack.position.z);

    var roundedString = fullHeight.toFixed(2);
    var rounded = Number(roundedString);
var textx = rounded.toString() + " mm";

    let sprite = new TextSprite({
//        text:   (rounded * 10)+ " mm",
        text:   textx,
        fontFamily: 'Open Sans, sans-serif',
        fontSize: 0.3,
        color: '#111111'
    });
    sprite.generateMipmaps = false;
    sprite.name = "TestSticker2";
   // scene.add(sprite);

    sprite.position.set( arrowHelper.position.x+2, (length / 2), arrowHelper.position.z);



    /////////////////////

    const originWidth = new THREE.Vector3(  0 , length.y/2 ,  0 );
    const lengthWidth =  fullWidth;
    const hexWidth = 0x404040;




    const arrowHelperWidth = new THREE.ArrowHelper( dirWidth, originWidth, lengthWidth, hexWidth,1 );


    var halfWidth = lengthWidth/2 ;

    arrowHelperWidth.position.set(-halfWidth , fullHeight+2,0);

    arrowHelperWidth.name = "ArrowWidth1";


    const arrowHelperWidth2 = new THREE.ArrowHelper( dirWidthBack, originWidth, lengthWidth, hexWidth,1 );
    arrowHelperWidth2.position.set(halfWidth , fullHeight+2, 0);
    arrowHelperWidth2.name = "ArrowWidth2";

    var roundedStringWidth = lengthWidth.toFixed(4);
    var roundedWidth = Number(roundedStringWidth);

    let spriteWidth = new TextSprite({
        text:   (roundedWidth * 10)+ " mm",
        fontFamily: 'Open Sans, sans-serif',
        fontSize: 0.5,
        color: '#111111'
    });

    spriteWidth.name = "TestStickerWidth";

    spriteWidth.position.set( 0 , arrowHelperWidth.position.y+0.5,0);
   log("fullheifht RULERS",fullHeight);

} else{

    var fullHeightAllObjects = 0;

    var fullWidthAllObjects = 0;

    for (let xc = 0; xc < scene.children.length; xc++) {

        if(scene.children[xc].type !== "GridHelper"){
            var box = new THREE.Box3().setFromObject( scene.getObjectByName( scene.children[xc].name) );
            var sizeBoxBody = box.getSize(new THREE.Vector3());
            fullHeightAllObjects = fullHeightAllObjects + sizeBoxBody.y;


            if(sizeBoxBody.x > fullWidthAllObjects){
                fullWidthAllObjects = sizeBoxBody.x;
            }

        }
    }


    var fullHeight = fullHeightAllObjects;


    const dir = new THREE.Vector3( 0,  1,  0);

    dir.normalize();

    const origin = new THREE.Vector3(  sizeBoxBody.x , 0,  0 );
    const length =  fullHeight;
    const hex = 0xffff00;

    const arrowHelper = new THREE.ArrowHelper( dir, origin, length, hex );


    arrowHelper.name = "ArrowHelper3";


    var scaleRounded = fullHeight * 10;
    var roundedString = scaleRounded.toFixed(2);
    var rounded = Number(roundedString);


}
if(!isPlugin){

    setTimeout(function(){
      /*  if(fullHeight > 9 ){
            camera.position.set(0, 15, -15);
        }
        if(fullHeight > 12 ){
            camera.position.set(0, 15, -20);
        }
        if(fullHeight > 13.5 ){
            camera.position.set(0, 17, -23);
        }
        if(fullHeight > 16 ){
            camera.position.set(0, 20, -23);
        }
        if(fullHeight > 19 ){
            camera.position.set(0, 30, -33);
        }

        if(fullHeight > 25 ){
            camera.position.set(0, 50, -33);
        }*/

        if(packageType !== "shrinks"){

console.log("FUl height", fullHeight);
            if(fullHeight > 25 ){
                var newX = 0- fullHeight;
                var newY = fullHeight+20;

                camera.position.set(0, newY, newX);
var newX = 0- fullHeight;
                var newY = fullHeight+20;
                console.log("FUl heigh22t", newX);
                camera.position.set(0, newY, newX);
                new TWEEN.Tween(camera.position).to({
                    x: 0,
                    z: newX,
                    y: newY
                }, 10).easing(TWEEN.Easing.Cubic.InOut).start();

                /*setTimeout(function(){

                    new TWEEN.Tween(camera.position).to({
                        x: 0,
                        z: -25,
                        y: 40
                    }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
                },200);*/
            } else {
                camera.position.set(0, -10, -25);
                new TWEEN.Tween(camera.position).to({
                    x: 0,
                    z: -25,
                    y: -10
                }, 10).easing(TWEEN.Easing.Cubic.InOut).start();

                setTimeout(function(){
                    new TWEEN.Tween(camera.position).to({
                        x: 0,
                        z: -25,
                        y: -10
                    }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
                },200);
            }

        } else {
            camera.position.set(0, 10, -25);
            new TWEEN.Tween(camera.position).to({
                x: 0,
                z: -25,
                y: 10
            }, 10).easing(TWEEN.Easing.Cubic.InOut).start();

            setTimeout(function(){

                new TWEEN.Tween(camera.position).to({
                    x: 0,
                    z: -25,
                    y: 10
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            },200);
        }



        if(closeLoadingInit){
            closeLoadingInit();
        }

    },1000);

} else {
    if(closeLoadingInit){
        closeLoadingInit();
    }
}




}
export function setUpCamerasFinal(closeLoadingInit){

    setTimeout(function(){


        setTimeout(function(){
            new TWEEN.Tween(camera.position).to({
                x: 0,
                z: -50,
                y: 15
            }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
        },200);


        if(closeLoadingInit){
            closeLoadingInit();
        }




    },1000);
};
export function ToggleRulers(rulersState){

    if(rulersState){
        if(scene.getObjectByName("TestSticker2") !== undefined){
           //    scene.getObjectByName("TestSticker2").visible = true;
         //    scene.getObjectByName("TestSticker2").material = new THREE.MeshBasicMaterial({
         //        transparent:true
         //    });
            if(TWEEN !== undefined){
                new TWEEN.Tween(scene.getObjectByName("TestSticker2").material).to({
                    opacity: 1,
                    transparent:true
                }, 300).easing(TWEEN.Easing.Linear.None).start();
            }
        }
        if(scene.getObjectByName("ArrowHelper1") !== undefined){
       //     scene.getObjectByName("ArrowHelper1").visible = true;
            scene.getObjectByName("ArrowHelper1").children[0].material.transparent=true;
            scene.getObjectByName("ArrowHelper1").children[0].material.needsUpdate = true;

            scene.getObjectByName("ArrowHelper1").children[1].material.transparent=true;
            scene.getObjectByName("ArrowHelper1").children[1].material.needsUpdate = true;

            if(TWEEN !== undefined){
                new TWEEN.Tween(scene.getObjectByName("ArrowHelper1").children[0].material).to({
                    opacity: 1,
                    transparent:true
                }, 300).easing(TWEEN.Easing.Linear.None).start();
                new TWEEN.Tween(scene.getObjectByName("ArrowHelper1").children[1].material).to({
                    opacity: 1,
                    transparent:true
                }, 300).easing(TWEEN.Easing.Linear.None).start();
            }

        }
        if(scene.getObjectByName("ArrowHelper1Back") !== undefined){
        //    scene.getObjectByName("ArrowHelper1Back").visible = true;
        //     scene.getObjectByName("ArrowHelper1Back").material = new THREE.MeshBasicMaterial({
        //         transparent:true
        //     });
            scene.getObjectByName("ArrowHelper1Back").children[0].material.transparent=true;
            scene.getObjectByName("ArrowHelper1Back").children[0].material.needsUpdate = true;

            scene.getObjectByName("ArrowHelper1Back").children[1].material.transparent=true;
            scene.getObjectByName("ArrowHelper1Back").children[1].material.needsUpdate = true;
            if(TWEEN !== undefined){
                new TWEEN.Tween(scene.getObjectByName("ArrowHelper1Back").children[0].material).to({
                    opacity: 1,
                    transparent:true
                }, 300).easing(TWEEN.Easing.Linear.None).start();
                new TWEEN.Tween(scene.getObjectByName("ArrowHelper1Back").children[1].material).to({
                    opacity: 1,
                    transparent:true
                }, 300).easing(TWEEN.Easing.Linear.None).start();
            }
        }
        if(scene.getObjectByName("ArrowWidth1") !== undefined){
            // scene.getObjectByName("ArrowWidth1").material = new THREE.MeshBasicMaterial({
            //     transparent:true
            // });
            scene.getObjectByName("ArrowWidth1").children[0].material.transparent=true;
            scene.getObjectByName("ArrowWidth1").children[0].material.needsUpdate = true;

            scene.getObjectByName("ArrowWidth1").children[1].material.transparent=true;
            scene.getObjectByName("ArrowWidth1").children[1].material.needsUpdate = true;
       //     scene.getObjectByName("ArrowWidth1").visible = true;
            if(TWEEN !== undefined){
                new TWEEN.Tween(scene.getObjectByName("ArrowWidth1").children[0].material).to({
                    opacity: 1,
                    transparent:true
                }, 300).easing(TWEEN.Easing.Linear.None).start();
                new TWEEN.Tween(scene.getObjectByName("ArrowWidth1").children[1].material).to({
                    opacity: 1,
                    transparent:true
                }, 300).easing(TWEEN.Easing.Linear.None).start();
            }
        }
        if(scene.getObjectByName("ArrowWidth2") !== undefined){
      //      scene.getObjectByName("ArrowWidth2").visible = true;
      //       scene.getObjectByName("ArrowWidth2").material = new THREE.MeshBasicMaterial({
      //           transparent:true
      //       });
            scene.getObjectByName("ArrowWidth2").children[0].material.transparent=true;
            scene.getObjectByName("ArrowWidth2").children[0].material.needsUpdate = true;

            scene.getObjectByName("ArrowWidth2").children[1].material.transparent=true;
            scene.getObjectByName("ArrowWidth2").children[1].material.needsUpdate = true;
            if(TWEEN !== undefined){
                new TWEEN.Tween(scene.getObjectByName("ArrowWidth2").children[0].material).to({
                    opacity: 1,
                    transparent:true
                }, 300).easing(TWEEN.Easing.Linear.None).start();
                new TWEEN.Tween(scene.getObjectByName("ArrowWidth2").children[1].material).to({
                    opacity: 1,
                    transparent:true
                }, 300).easing(TWEEN.Easing.Linear.None).start();
            }
        }
        if(scene.getObjectByName("TestStickerWidth") !== undefined){
         //  scene.getObjectByName("TestStickerWidth").visible = true;
          //   scene.getObjectByName("TestStickerWidth").material = new THREE.MeshBasicMaterial({
          //       transparent:true
          //   });
            if(TWEEN !== undefined){
                new TWEEN.Tween(scene.getObjectByName("TestStickerWidth").material).to({
                    opacity: 1,
                    transparent:true
                }, 300).easing(TWEEN.Easing.Linear.None).start();
            }
        }

    } else{
        if(scene.getObjectByName("TestSticker2") !== undefined){
            // scene.getObjectByName("TestSticker2").material = new THREE.MeshStandardMaterial({
            //     transparent:true,
            //     depthWrite: false
            // });

            if(TWEEN !== undefined){
                new TWEEN.Tween(scene.getObjectByName("TestSticker2").material).to({
                    opacity: 0,
                    transparent:true
                }, 300).easing(TWEEN.Easing.Linear.None).start();
            }
        }
        if(scene.getObjectByName("ArrowHelper1") !== undefined){
            //     scene.getObjectByName("ArrowHelper1").visible = true;

            if(TWEEN !== undefined){
                // scene.getObjectByName("ArrowHelper1").material = new THREE.MeshBasicMaterial({
                //    transparent:true
                // });
                scene.getObjectByName("ArrowHelper1").children[0].material.transparent=true;
                scene.getObjectByName("ArrowHelper1").children[0].material.needsUpdate = true;

                scene.getObjectByName("ArrowHelper1").children[1].material.transparent=true;
                scene.getObjectByName("ArrowHelper1").children[1].material.needsUpdate = true;
                new TWEEN.Tween(scene.getObjectByName("ArrowHelper1").children[0].material).to({
                    opacity: 0,
                    transparent:true
                }, 300).easing(TWEEN.Easing.Linear.None).start();
                new TWEEN.Tween(scene.getObjectByName("ArrowHelper1").children[1].material).to({
                    opacity: 0,
                    transparent:true
                }, 300).easing(TWEEN.Easing.Linear.None).start();

        }
        if(scene.getObjectByName("ArrowHelper1Back") !== undefined){
            //    scene.getObjectByName("ArrowHelper1Back").visible = true;
            // scene.getObjectByName("ArrowHelper1Back").material = new THREE.MeshBasicMaterial({
            //     transparent:true
            // });
            scene.getObjectByName("ArrowHelper1Back").children[0].material.transparent=true;
            scene.getObjectByName("ArrowHelper1Back").children[0].material.needsUpdate = true;

            scene.getObjectByName("ArrowHelper1Back").children[1].material.transparent=true;
            scene.getObjectByName("ArrowHelper1Back").children[1].material.needsUpdate = true;
            if(TWEEN !== undefined){
                new TWEEN.Tween(scene.getObjectByName("ArrowHelper1Back").children[0].material).to({
                    opacity: 0,
                    transparent:true
                }, 300).easing(TWEEN.Easing.Linear.None).start();
                new TWEEN.Tween(scene.getObjectByName("ArrowHelper1Back").children[1].material).to({
                    opacity: 0,
                    transparent:true
                }, 300).easing(TWEEN.Easing.Linear.None).start();
            }
        }
        if(scene.getObjectByName("ArrowWidth1") !== undefined){
            //     scene.getObjectByName("ArrowWidth1").visible = true;
            // scene.getObjectByName("ArrowWidth1").material = new THREE.MeshBasicMaterial({
            //     transparent:true
            // });
            scene.getObjectByName("ArrowWidth1").children[0].material.transparent=true;
            scene.getObjectByName("ArrowWidth1").children[0].material.needsUpdate = true;

            scene.getObjectByName("ArrowWidth1").children[1].material.transparent=true;
            scene.getObjectByName("ArrowWidth1").children[1].material.needsUpdate = true;
            if(TWEEN !== undefined){
                new TWEEN.Tween(scene.getObjectByName("ArrowWidth1").children[0].material).to({
                    opacity: 0,
                    transparent:true
                }, 300).easing(TWEEN.Easing.Linear.None).start();
                new TWEEN.Tween(scene.getObjectByName("ArrowWidth1").children[1].material).to({
                    opacity: 0,
                    transparent:true
                }, 300).easing(TWEEN.Easing.Linear.None).start();
            }
        }
        if(scene.getObjectByName("ArrowWidth2") !== undefined){
            scene.getObjectByName("ArrowWidth2").children[0].material.transparent=true;
            scene.getObjectByName("ArrowWidth2").children[0].material.needsUpdate = true;

            scene.getObjectByName("ArrowWidth2").children[1].material.transparent=true;
            scene.getObjectByName("ArrowWidth2").children[1].material.needsUpdate = true;
            if(TWEEN !== undefined){

                new TWEEN.Tween(scene.getObjectByName("ArrowWidth2").children[0].material).to({
                    opacity: 0,
                    transparent:true
                }, 300).easing(TWEEN.Easing.Linear.None).start();

                new TWEEN.Tween(scene.getObjectByName("ArrowWidth2").children[1].material).to({
                    opacity: 0,
                    transparent:true
                }, 300).easing(TWEEN.Easing.Linear.None).start();
            }
        }
        if(scene.getObjectByName("TestStickerWidth") !== undefined){
            if(TWEEN !== undefined){
                new TWEEN.Tween(scene.getObjectByName("TestStickerWidth").material).to({
                    opacity: 0,
                    transparent:true
                }, 300).easing(TWEEN.Easing.Linear.None).start();
            }
        }
    }
//render();
}
}

export function ToggleDeveloperGUI(guiState){

    if(guiState){
        setUPEditUI();

    } else{
        if(gui){
            gui.destroy();
        }

    }
  //  render();
}

export function ToggleGrid(gridState){

    if(gridState){
        if(scene.getObjectByName("GridScene") !== undefined){

            if(TWEEN !== undefined){
                new TWEEN.Tween(scene.getObjectByName("GridScene").material).to({
                    opacity: gridOpacity
                }, 300).easing(TWEEN.Easing.Linear.None).start();
            }

         //   scene.getObjectByName("GridScene").visible = true;
        }
    } else{
        if(scene.getObjectByName("GridScene") !== undefined){
            if(TWEEN !== undefined){
                new TWEEN.Tween(scene.getObjectByName("GridScene").material).to({
                    opacity: 0
                }, 300).easing(TWEEN.Easing.Linear.None).start();
            }
           // scene.getObjectByName("GridScene").visible = false;
        }
    }
    render();
}

var openingX = 0;
var openingY = 0;
var openingZ = 0;

var gltfOpening = null;


export function loadNewOpeningModel( newOpeningModel: string | undefined, scaleFactor, callBackFunction) {

   // var scaleFactor = 100;
    const loadingManager1 = new THREE.LoadingManager();
    loadingManager1.onLoad = function ( ) {

    };

    const ktx2Loader = new KTX2Loader()
        .setTranscoderPath( 'three/examples/js/libs/basis/' )
        .detectSupport( renderer );

    // @ts-ignore
    const loader = new GLTFLoader(loadingManager1);

    loader.setKTX2Loader( ktx2Loader );
    loader.setMeshoptDecoder( MeshoptDecoder );
console.log("LOADING", newOpeningModel);

    loader.load(newOpeningModel, (gltf) => onLoadOpening(gltf), onLoad, onError);

    const onLoadOpening = (gltf2) => {

        var openingName= "";
        // gltf2.scene.position.copy(new THREE.Vector3(openingX, openingY, openingZ));
        //gltf2.scene.scale.copy(new THREE.Vector3(scaleFactor, scaleFactor, scaleFactor));
        gltf2.scene.name = "OpeningGroup";
        scene.add(gltf2.scene);
        var textureLoader = new THREE.TextureLoader();
        var textureMetalBump = textureLoader.load('/textures/500mlStandard/metal_tex.jpg');
        textureMetalBump.flipY = false;

        gltf2.scene.traverse(function(child) {

            // @ts-ignore
            if (child.isMesh && !child.name.includes("CAP")) {
                child.material = new THREE.MeshStandardMaterial({
                    map: null, normalMap : null, aoMap : null,envMap: envMap,
                    aoMapIntensity : 0, emissiveIntensity : 0,
                    metalness: 0.2,  roughness : 0.2,color: 0x1259cf, emissive :0x000000
                });
                // child.material.roughness = 0.23;
                child.material.needsUpdate = true;
            }

            if (child.isMesh && child.name.includes("plate")) {
                child.material = new THREE.MeshStandardMaterial({
                    map: null, normalMap : null, aoMap : null,envMap: envMap,
                    aoMapIntensity : 0, emissiveIntensity : 0,
                    metalness: 0.2,  roughness : 0.1,color: 0xdedede, emissive :0x000000
                });
                // child.material.roughness = 0.23;
                child.material.needsUpdate = true;
            }

            if(child.isMesh){
                child.material.transparent = true;
             //   child.material.opacity = 0;
                child.material.needsUpdate = true;
                child.visible=false;
            }

            if (child.name.includes("opening_") ||  child.name.includes("OPENING_")) {
                openingName = child.name;
            }
        //    child.visible = false;
        });
      //  console.log("nastavujeme", scene.getObjectByName(openingName+"_locator"), scene.getObjectByName(openingName+"_locator").position.x, scene.getObjectByName(openingName+"_locator").position.y,scene.getObjectByName(openingName+"_locator").position.z, scaleFactor);
console.log("nastaveni 1", openingName,  scene, scene.getObjectByName(openingName+"_locator"));

        if(openingName !== ""  && scene.getObjectByName(openingName+"_locator") !== undefined){
            gltf2.scene.position.copy(new THREE.Vector3(scene.getObjectByName(openingName+"_locator").position.x*scaleFactor, scene.getObjectByName(openingName+"_locator").position.y*scaleFactor, scene.getObjectByName(openingName+"_locator").position.z*scaleFactor));
            gltf2.scene.rotation.copy(scene.getObjectByName(openingName+"_locator").rotation);
            gltf2.scene.scale.copy((new THREE.Vector3(scene.getObjectByName(openingName+"_locator").scale.x*scaleFactor, scene.getObjectByName(openingName+"_locator").scale.y*scaleFactor, scene.getObjectByName(openingName+"_locator").scale.z*scaleFactor)));
            log("nastavujemeee", scene.getObjectByName(openingName+"_locator").position, scaleFactor, packageTypeGlobal, openingName, scene.getObjectByName(openingName+"_locator").rotation);
        } else {

            gltf2.scene.scale.copy(new THREE.Vector3(scaleFactor, scaleFactor, scaleFactor));
        }
        if(callBackFunction){
            console.log("callin back 1");
            callBackFunction();
        }
        return "loadingComplete";

    };

    const onProgress= (progressLoading) => {

    };
    // the loader will report the loading progress to this function
    const onLoad = (progressLoading) => {

    };

    // the loader will send any error messages to this function, and we'll log
    // them to to console
    let onError: (errorMessage: any) => void;
    onError = errorMessage => {
        if(callBackFunction){
            console.log("callin back 2");
            callBackFunction();
        }
        return "loadingError";

    };





};

 function oddelitBarvuAAlfu(hex) {
    // Odstraníme znak "#" (pokud existuje)
    const bezMrizky = hex.replace('#', '');

    // Pokud hex kód obsahuje 8 znaků (RRGGBBAA)
    if (bezMrizky.length === 8) {
        // Prvních 6 znaků je samotná barva
        const barva = `#${bezMrizky.substring(0, 6)}`;
        // Poslední 2 znaky představují alfa kanál v hex formátu
        const alfaHex = bezMrizky.substring(6);
        // Převod alfa kanálu na číslo od 0 do 1
        const alfaCislo = parseInt(alfaHex, 16) / 255;
        return { barva, alfaHex, alfaCislo };
    }

    // Pokud hex kód neobsahuje alfa, vrátíme původní barvu
    return { barva: hex, alfaHex: null, alfaCislo: null };
}
export function changeOpeningModelVisibility( newOpeningModel: string | undefined, packageOpenings, color) {
  /*  scene.getObjectByName("OPENING_SIP").material.transparent =false;
    scene.getObjectByName("OPENING_FLAT").material.transparent =false;
    scene.getObjectByName("OPENING_SIP").visible =false;
    scene.getObjectByName("OPENING_FLAT").visible =false;
    scene.getObjectByName("OPENING_SIP").material.needsUpdate = true;
    scene.getObjectByName("OPENING_FLAT").material.needsUpdate = true;
    scene.getObjectByName("OPENING_SIP").needsUpdate = true;
    scene.getObjectByName("OPENING_FLAT").needsUpdate = true;
    console.log("scnce ", scene);
    */
console.log("CHANGE MODEL", newOpeningModel);
    packageOpenings.map((openingItem => {
console.log(openingItem.description , scene, newOpeningModel);

if(openingItem.description !== newOpeningModel){
    if( scene.getObjectByName(openingItem.description) !== undefined){
        scene.getObjectByName(openingItem.description).traverse(function(child) {
            // @ts-ignore
            child.visible = false;

           /* if(child.isMesh){
                child.material.transparent = true;
                child.material.opacity = 0;
                child.material.needsUpdate = true;
            }
                */
        });
    }
} else {
    if( scene.getObjectByName(openingItem.description) !== undefined){
    scene.getObjectByName(openingItem.description).traverse(function(child) {
        // @ts-ignore
        child.visible = true;
        if(color){

            const hexBarva = color;

            const vysledek = oddelitBarvuAAlfu(hexBarva);

            child.material.color.setHex('0x' + vysledek.barva.replace("#",""));
            child.material.transparent = true;
            child.material.opacity = vysledek.alfaCislo;
            child.material.needsUpdate = true;

        }
    //    console.log("CHILD ", child);
     /*   if(child.isMesh){
            child.material.transparent = false;
            child.material.opacity = 1;
            child.material.needsUpdate = true;
        }*/

    });
    }
}


    }));


};



export function loadTexturesInside(url) {

    var model = scene;

    var loader = new THREE.TextureLoader();
    loader.crossOrigin = "";

    loader.load(
        url,
        function( texture ) {
            texture.flipY= false;
            //texture.colorSpace = THREE.SRGBColorSpace;
            model.traverse(o => {

                    if (o.isMesh &&(o.name === 'BODY_CAN_500_1'
                        || o.name === 'BODY_CAN_500_2'  || o.name === 'BODY_CAN_500_3'||  o.name === "BODY_CAN_500_4"
                        || o.name === 'BODY_CAN_500_5'  || o.name === 'BODY_CAN_500_6'||  o.name === "BODY_CAN_500_7"
                        ||  o.name === "BODY_CAN_500_8"||  o.name === "BODY_CAN_500_9"
                        ||  o.name === "BODY_CAN_500_10"
                        ||  o.name === "BODY_CAN_500_11"
                        ||  o.name === "BODY_CAN_500_12"
                    )) {

                        bodyMainTextureSaved =url;
                        texture.colorSpace = THREE.SRGBColorSpace;
                        o.material.map = texture;

                        o.material.needsUpdate = true;

                        var textureLoader = new THREE.TextureLoader();
                        var textureMetalBumpB = textureLoader.load('/textures/500mlStandard/metal_tex.jpg');
                        textureMetalBumpB.flipY = false;


                        o.material = new THREE.MeshStandardMaterial({
                            map: texture, normalMap : null, aoMap : null,       envMap: envMap,
                            metalness: 0.25,  roughness : 0.4, aoMapIntensity : 0, emissiveIntensity : 0,
                            bumpMap: textureMetalBumpB, bumpScale: 0.15

                        });


                }
            });

        },
        function () {},  // onProgress function
        function ( error ) {

            //
        } // onError function
    );


}



///////////////////////////////////////////////////////////////////////////////////// LOAD MODELS
export function loadModel(bodyModel: string | undefined, openingModel: string | undefined, callbackFunction, scaleFactor, typeLoad, packageType, packageDescription) {
        log("LOADING BODY ",bodyModel, openingModel);
    scaleFactor = 100;
    savedOriginalPackModel = bodyModel;
    savedOriginalOpeningModel =openingModel;



    var hdrJpg= new HDRJPGLoader(renderer)
        .load('/textures/warehouse_jpg2.jpg', function () {
            var hdrJpgEquirectangularMap = hdrJpg.renderTarget.texture;
            hdrJpgEquirectangularMap.mapping = THREE.EquirectangularReflectionMapping;
            hdrEquirect = hdrJpgEquirectangularMap;


             if(scene.getObjectByName("BODY") && packageTypeGlobal === "glass-bottles"){
               scene.getObjectByName("BODY").material.envMap = hdrJpgEquirectangularMap;
                 scene.getObjectByName("BODY").material.needsUpdate = true;
                 scene.getObjectByName("BODY").needsUpdate = true;
            }
            if(scene.getObjectByName("FLUID") && packageTypeGlobal === "glass-bottles"){
                scene.getObjectByName("FLUID").material.envMap = hdrJpgEquirectangularMap;
                scene.getObjectByName("FLUID").material.needsUpdate = true;
                scene.getObjectByName("FLUID").needsUpdate = true;
            }
        }, function (progress) {

        });



    const loadingManager1 = new THREE.LoadingManager();
    loadingManager1.onLoad = function ( ) {
    };

    const ktx2Loader = new KTX2Loader()
        .setTranscoderPath( 'three/examples/js/libs/basis/' )
        .detectSupport( renderer );

    // @ts-ignore
    const loader = new GLTFLoader(loadingManager1);

    loader.setKTX2Loader( ktx2Loader );
    loader.setMeshoptDecoder( MeshoptDecoder );

    // LOAD BODY MODEL
    loader.load(bodyModel, (gltf) => onLoadCoreModel(gltf), onProgress, onError);




    const onLoadCoreModel = (gltf) => {

        if(typeLoad === "normal"){
            gltf.scene.position.copy(new THREE.Vector3(0, 0, 0));
        } else {
            gltf.scene.position.set( 0, 0, - 0.3 ).applyMatrix4( typeLoad );
          //  mesh.quaternion.setFromRotationMatrix( controller.matrixWorld );
        }

        var textureLoader = new THREE.TextureLoader();
        var textureRoughness = textureLoader.load('/textures/500mlStandard/metal2048.jpg');
        textureRoughness.flipY = false;

        var textureMetalness = textureLoader.load('/textures/500mlStandard/mainRough2.png');
        textureMetalness.flipY = false;


        gltf.scene.scale.copy(new THREE.Vector3(scaleFactor, scaleFactor, scaleFactor));
        gltf.name = "BodyModelScene";
        scene.add(gltf.scene);

        var textureLoader = new THREE.TextureLoader();
        var textureMetalBumpB = textureLoader.load('/textures/500mlStandard/metal_tex.jpg');
        textureMetalBumpB.flipY = false;




        gltf.scene.traverse(function(child) {
            if(child.isGroup && child.name === "BODY" ||  child.name === "Package"  ){
                child.name="BodyGroup"
            }


            if (child.isMesh  && child.name === "BODY_BOTTOM") {
                // metalness: 0.2,  roughness : 0.2, metalness: 0.6,  roughness : 0.35,



                const r = "/textures/refraction_hdr/studio/";

                const urls = [
                    r + "px.png", r + "nx.png",
                    r + "py.png", r + "ny.png",
                    r + "pz.png", r + "nz.png"
                ];

                const textureCubeXX = new THREE.CubeTextureLoader().load(urls, function (newMap) {

                    child.material = new THREE.MeshStandardMaterial({
                        map: null, normalMap : null, aoMap : null,envMap: newMap,
                        aoMapIntensity : 0, emissiveIntensity : 0,
                        color: 0xffffff,
                        metalness: 0.8,
                        roughness : 0.25,
                        bumpMap: textureMetalBumpB, bumpScale: 0.15
                    });

                    child.material.needsUpdate = true;

                    }
                );


            }
            if (child.isMesh && (child.name === "FLUID")) {
                mesh = child;

                if(packageType === "glass-bottles"){

                    const textureLoader = new THREE.TextureLoader();
                    const normalMapTexture = textureLoader.load("/textures/normal.jpg");
                    normalMapTexture.wrapS = THREE.RepeatWrapping;
                    normalMapTexture.wrapT = THREE.RepeatWrapping;
                    normalMapTexture.repeat.set(3, 3);
                    child.material = new THREE.MeshPhysicalMaterial( {
                        color: 0x905426,
                        metalness: 0.05,
                        roughness: 0.05,
                        ior: 1,
                        thickness:  1,
                        envMap: hdrEquirect,
                        envMapIntensity: 1,
                        transmission: 1, // use material.transmission for glass materials
                        specularIntensity: 1,
                        specularColor: 0xffffff,
                        opacity: 0.7,
                        side: THREE.DoubleSide,
                        transparent: true,
                        //   normalScale: new THREE.Vector2(0.2),
                        //    normalMap: normalMapTexture,
                        clearcoatNormalMap: normalMapTexture,
                        clearcoatNormalScale: new THREE.Vector2(0.1),
                    } );

                    child.renderOrder= 10;
                    child.material.renderOrder=2;



                    child.material.needsUpdate = true;
                }
            }
            // @ts-ignore
            if (child.isMesh && (child.name === "BODY" || child.name === "BODY_1" ||  child.name === "Package")) {
                mesh = child;

                if(packageType === "glass-bottles"){

                    const textureLoader = new THREE.TextureLoader();
                    const normalMapTexture = textureLoader.load("/textures/normal.jpg");
                    normalMapTexture.wrapS = THREE.RepeatWrapping;
                    normalMapTexture.wrapT = THREE.RepeatWrapping;
                    normalMapTexture.repeat.set(3, 3);
                    child.material = new THREE.MeshPhysicalMaterial( {
                        color: 0x00652e,
                        metalness: 0.05,
                        roughness: 0.05,
                        ior: 1,
                        thickness:  1,
                        envMap: hdrEquirect,
                        envMapIntensity: 1,
                        transmission: 1, // use material.transmission for glass materials
                        specularIntensity: 1,
                        specularColor: 0xffffff,
                        opacity: 0.7,
                        side: THREE.DoubleSide,
                        transparent: true,
                     //   normalScale: new THREE.Vector2(0.2),
                    //    normalMap: normalMapTexture,
                    //     clearcoatNormalMap: normalMapTexture,
                    //     clearcoatNormalScale: new THREE.Vector2(0.1),
                    } );

                    child.renderOrder= 10;
                    child.material.renderOrder=2;

                    if(packageDescription !== "FBIT700" && packageDescription !== "SPFRUKO 500 ml"){

                        child.material.normalScale = new THREE.Vector2(0.2);
                        child.material.normalMap = normalMapTexture;
                        child.material.needsUpdate = true;
                    }



                    child.material.needsUpdate = true;

                } else {


                    const r = "/textures/refraction_hdr/studio/";

                    const urls = [
                        r + "px.png", r + "nx.png",
                        r + "py.png", r + "ny.png",
                        r + "pz.png", r + "nz.png"
                    ];

                    const textureCubeXX = new THREE.CubeTextureLoader().load(urls, function (newMap) {

                        child.material = new THREE.MeshStandardMaterial({
                            map: null, normalMap : null, aoMap : null,
                            envMap: newMap,
                            metalness: 0.6,  roughness : 0.35,
                            aoMapIntensity : 0,
                            emissiveIntensity : 0,
                            bumpMap: textureMetalBumpB,
                            bumpScale: 0.2
                        });
                        child.material.needsUpdate = true;

                        }
                    );

                }


                        if(packageDescription === "FBIT700"){
                            const textureLoader = new THREE.TextureLoader();
                            const normalMapTexture = textureLoader.load("/textures/FBIT700/normalMap_FBIT700.jpg");
                            normalMapTexture.flipY = false;
                            child.material.bumpMap = normalMapTexture;
                            child.material.bumpMapScale= 3;
                            child.material.needsUpdate = true;

                        }
                if(packageDescription === "SPFRUKO 500 ml"){
                    const textureLoader = new THREE.TextureLoader();
                    const normalMapTexture = textureLoader.load("/textures/SPFRUKO500/normalMap_SPFRUKO500.jpg");
                    normalMapTexture.flipY = false;
                    child.material.bumpMap = normalMapTexture;
                    child.material.bumpMapScale= 3;
                    child.material.needsUpdate = true;
                }


                child.material.needsUpdate = true;
            }

            if(openingModel !== null && openingModel !== undefined){

                if (child.name == 'CAP_locator' || child.name.includes("_locator")) {

                    // @ts-ignore
                    openingY = child.position.y*scaleFactor;
                    openingX = child.position.x*scaleFactor;
                    openingZ = child.position.z*scaleFactor;

                    var textureLoader = new THREE.TextureLoader();
                    var textureMetalShadow = textureLoader.load('/textures/box_shadow.png');
                    textureMetalShadow.flipY = false;

                    var textureLoader = new THREE.TextureLoader();
                    var textureMetalBumpA = textureLoader.load('/textures/box_shadow_alpha.png');
                    textureMetalBumpA.flipY = false;

                    var geo = new THREE.PlaneGeometry(15, 15, 5, 5);
                    var mat = new THREE.MeshBasicMaterial({ color: 0x000000, side: THREE.DoubleSide, opacity:0.23, map:textureMetalShadow, alphaMap: textureMetalBumpA,transparent:true });
                    var plane = new THREE.Mesh(geo, mat);
                    plane.name="shadoow";
                    scene.add(plane);
                    plane.position.set(0,0,0);
                    plane.renderOrder=1;
                    plane.rotateX( - Math.PI / 2);

                }

            }


        });
        if(typeLoad !== "normal"){
      changeTexture("bodyMainTexture", bodyMainTextureSaved);
        }

        if(openingModel === null){

                if(callbackFunction !== null){
                    callbackFunction("null");
                }

                return "loadingComplete";

                render();

        } else {

            loader.load(openingModel, (gltf) => onLoadOpening(gltf), onLoad, onError);
        }

        render();
    };

    const onLoadOpening = (gltf2) => {

        gltfOpening = gltf2;
        var openingName= "";

       // gltfOpening.scene.position.copy(new THREE.Vector3(openingX, openingY, openingZ));
        //gltfOpening.scene.scale.copy(new THREE.Vector3(scaleFactor, scaleFactor, scaleFactor));
        gltfOpening.scene.name = "OpeningGroup";
        scene.add(gltfOpening.scene);
        var textureLoader = new THREE.TextureLoader();
        var textureMetalBump = textureLoader.load('/textures/500mlStandard/metal_tex.jpg');
        textureMetalBump.flipY = false;

        gltfOpening.scene.traverse(function(child) {
            // @ts-ignore
            if (child.isMesh  && child.name.includes("CAP")) {

                child.material = new THREE.MeshStandardMaterial({
                    map: null, normalMap : null, aoMap : null,envMap: envMap,
                    aoMapIntensity : 0, emissiveIntensity : 0,
                    metalness: 0.9,  roughness : 0.23, bumpMap: textureMetalBump, bumpScale: 0.2
                });
                child.material.roughness = 0.23;
                child.material.needsUpdate = true;
            }



            // @ts-ignore
            if (child.isMesh && !child.name.includes("CAP")) {

                child.material = new THREE.MeshStandardMaterial({
                    map: null, normalMap : null, aoMap : null,envMap: envMap,
                    aoMapIntensity : 0, emissiveIntensity : 0,
                     metalness: 0.2,  roughness : 0.2,color: 0x1259cf, emissive :0x000000
                });
               // child.material.roughness = 0.23;
                child.material.needsUpdate = true;
            }

            if (child.isMesh && child.name.includes("plate")) {

                child.material = new THREE.MeshStandardMaterial({
                    map: null, normalMap : null, aoMap : null,envMap: envMap,
                    aoMapIntensity : 0, emissiveIntensity : 0,
                    metalness: 0.2,  roughness : 0.1,color: 0xdedede, emissive :0x000000
                });
                // child.material.roughness = 0.23;
                child.material.needsUpdate = true;
            }

            if (child.isMesh  && child.name === "PLATE") {

                child.material = new THREE.MeshStandardMaterial({
                    map: null, normalMap : null, aoMap : null,envMap: envMap,
                    aoMapIntensity : 0, emissiveIntensity : 0,
                    metalness: 0.9,  roughness : 0.23, bumpMap: textureMetalBump, bumpScale: 0.2
                });
                child.material.roughness = 0.23;
                child.material.needsUpdate = true;
            }


            if (child.name.includes("opening_") ||  child.name.includes("OPENING_")) {
                openingName = child.name;
            }
            if (child.name == 'CAP_OPENER_FULL') {
                child.visible = false;
            }
        });

            log("OPENING BRO", packageTypeGlobal, openingName,scene.getObjectByName(openingName+"_locator").scale);

        if(openingName !== ""  && scene.getObjectByName(openingName+"_locator") !== undefined){
            gltfOpening.scene.position.copy(new THREE.Vector3(scene.getObjectByName(openingName+"_locator").position.x*scaleFactor, scene.getObjectByName(openingName+"_locator").position.y*scaleFactor, scene.getObjectByName(openingName+"_locator").position.z*scaleFactor));
            gltfOpening.scene.rotation.copy(scene.getObjectByName(openingName+"_locator").rotation);
            gltfOpening.scene.scale.copy((new THREE.Vector3(scene.getObjectByName(openingName+"_locator").scale.x*scaleFactor, scene.getObjectByName(openingName+"_locator").scale.y*scaleFactor, scene.getObjectByName(openingName+"_locator").scale.z*scaleFactor)));
            log("INNA BRO", scene.getObjectByName(openingName+"_locator").position, scaleFactor, packageTypeGlobal, openingName, scene.getObjectByName(openingName+"_locator").rotation);
        } else {

            gltfOpening.scene.scale.copy(new THREE.Vector3(scaleFactor, scaleFactor, scaleFactor));
        }



        if(callbackFunction !== null){
            callbackFunction(openingY / scaleFactor);
        }

        return "loadingComplete";

        render();
    };

    const onProgress= (progressLoading) => {

    };
    // the loader will report the loading progress to this function
    const onLoad = (progressLoading) => {

    };

    // the loader will send any error messages to this function, and we'll log
    // them to to console
    let onError: (errorMessage: any) => void;
    onError = errorMessage => {
        return "loadingError";

    };
}

export const rotateProductShrinkInsideDefault = (value) =>{


    if('1' in value ){

        if( scene.getObjectByName("BODY_CAN_500_1")){
            scene.getObjectByName("BODY_CAN_500_1").rotation.y = (Math.PI / 180) * value["1"];
        }

    }
    if('2' in value ){

        if( scene.getObjectByName("BODY_CAN_500_2")){
            scene.getObjectByName("BODY_CAN_500_2").rotation.y = (Math.PI / 180) * value["2"];
        }

    }
    if('3' in value ){

        if( scene.getObjectByName("BODY_CAN_500_3")){
            scene.getObjectByName("BODY_CAN_500_3").rotation.y = (Math.PI / 180) * value["3"];
        }
    }
    if('4' in value ){

        if( scene.getObjectByName("BODY_CAN_500_4")){
            scene.getObjectByName("BODY_CAN_500_4").rotation.y = (Math.PI / 180) * value["4"];
        }

    }
    if('5' in value ){

        if( scene.getObjectByName("BODY_CAN_500_5")){
            scene.getObjectByName("BODY_CAN_500_5").rotation.y = (Math.PI / 180) * value["5"];
        }

    }
    if('6' in value ){
        if( scene.getObjectByName("BODY_CAN_500_6")){
            scene.getObjectByName("BODY_CAN_500_6").rotation.y = (Math.PI / 180) * value["6"];
        }

    }
    if('7' in value ){

        if( scene.getObjectByName("BODY_CAN_500_7")){
            scene.getObjectByName("BODY_CAN_500_7").rotation.y = (Math.PI / 180) * value["7"];
        }

    }
    if('8' in value ){

        if( scene.getObjectByName("BODY_CAN_500_8")){
            scene.getObjectByName("BODY_CAN_500_8").rotation.y = (Math.PI / 180) * value["8"];
        }


    }
    if('9' in value ){

        if( scene.getObjectByName("BODY_CAN_500_9")){
            scene.getObjectByName("BODY_CAN_500_9").rotation.y = (Math.PI / 180) * value["9"];
        }

    }
    if('10' in value ){

        if( scene.getObjectByName("BODY_CAN_500_10")){
            scene.getObjectByName("BODY_CAN_500_10").rotation.y = (Math.PI / 180) * value["10"];
        }


    }
    if('11' in value ){
        if( scene.getObjectByName("BODY_CAN_500_11")){
            scene.getObjectByName("BODY_CAN_500_11").rotation.y = (Math.PI / 180) * value["11"];
        }


    }
    if('12' in value ){

        if( scene.getObjectByName("BODY_CAN_500_12")){
            scene.getObjectByName("BODY_CAN_500_12").rotation.y = (Math.PI / 180) * value["12"];
        }


    }

}
function rotateAroundObjectAxis(object, axis, radians) {
    var rotationMatrix = new THREE.Matrix4();

    rotationMatrix.makeRotationAxis(axis.normalize(), radians);
    object.matrix.multiply(rotationMatrix);
    object.rotation.setFromRotationMatrix( object.matrix );

}

function rotateAroundWorldAxis( object, axis, radians ) {

    var rotationMatrix = new THREE.Matrix4();

    rotationMatrix.makeRotationAxis( axis.normalize(), radians );
    rotationMatrix.multiply( object.matrix );                       // pre-multiply
    object.matrix = rotationMatrix;
    object.rotation.setFromRotationMatrix( object.matrix );
}
export const rotateProductDefault = (value, isSides) =>{

    if(scene && scene.getObjectByName("BODY")){
        if(isSides){
            if(scene.getObjectByName("Scene")){
             scene.getObjectByName("Scene").rotation.y =  (Math.PI / 180) * value;
            }
        } else {
            if(scene.getObjectByName("BODY")){

                var rotationInDegrees = value;
                var newValue = THREE.MathUtils.degToRad(rotationInDegrees);

                if(packageTypeGlobal === "glass-bottles"){
                    if(scene.getObjectByName("BODY")){
                        scene.getObjectByName("BODY").rotation.y = newValue;
                    }
                    if(scene.getObjectByName("Label_TOP")){
                        scene.getObjectByName("Label_TOP").rotation.y = newValue;
                    }
                    if(scene.getObjectByName("LABEL_BODY")){
                        scene.getObjectByName("LABEL_BODY").rotation.y =newValue;
                    }
                    if(scene.getObjectByName("LABEK_BODY")){
                        scene.getObjectByName("LABEK_BODY").rotation.y = newValue;
                    }
                    if(scene.getObjectByName("Label_Main")){
                        scene.getObjectByName("Label_Main").rotation.y = newValue;
                    }
                    if(scene.getObjectByName("Vicko")){
                        scene.getObjectByName("Vicko").rotation.y = newValue;
                    }
                } else if(packageTypeGlobal === "drink-cups"){
                    scene.getObjectByName("BODY").rotation.y = THREE.MathUtils.degToRad(rotationInDegrees);
                    scene.getObjectByName("Label").rotation.y = THREE.MathUtils.degToRad(rotationInDegrees);
                }else if(packageTypeGlobal === "plastic-drink-cups"){
                    scene.getObjectByName("BODY").rotation.y = THREE.MathUtils.degToRad(rotationInDegrees);
                    scene.getObjectByName("Label").rotation.y = THREE.MathUtils.degToRad(rotationInDegrees);
                }else{
                    scene.getObjectByName("BODY").rotation.y = THREE.MathUtils.degToRad(rotationInDegrees);
                }


            }
        }
        if(scene.getObjectByName("OpeningGroup")){
            scene.getObjectByName("OpeningGroup").rotation.y = (Math.PI / 180) * value;
        }
    }
}

export const createDownloadAR = async () => {


    const exporter = new USDZExporter();
    const arraybuffer = await exporter.parse(scene);
    const blob = new Blob([arraybuffer], { type: 'application/octet-stream' });

    const link = document.getElementById('ARLink');
    if (link !== null) {
        link.href = URL.createObjectURL(blob);
    }


};

///////////////////////////////////////////////////////////////////////////////////// LOAD MODELS END

///////////////////////////////////////////////////////////////////////////////////// LOAD MODELS
export function loadModelFromInput(mainModel, callbackFunction) {
    var openingY = 0;


    while(scene.children.length > 1){
        if(scene.children[0].type !== "GridHelper"){
            scene.remove(scene.children[0]);
        } else{
            scene.remove(scene.children[1]);
        }
    }


    var dae_path;

    var extraFiles = {}, file;


        let fileX = mainModel;
        let reader = new FileReader();

        // This is code that runs after reader.readAsText() finishes
        reader.onload = function ( gltfText ) {

            var loader = new GLTFLoader();

            loader.parse( gltfText.target.result, '', function( gltf ){
                   gltf.scene.position.copy(new THREE.Vector3(0, 0, 0));
                 gltf.scene.scale.copy(new THREE.Vector3(100, 100, 100));
                scene.add( gltf.scene );


            }, function( errormsg ){

                console.error( errormsg );
            });
        };


    reader.readAsText( fileX );

}


var callBackComment = null;
var commentsLength = 0;

var commentsEnabled= true;
export function setCommentMode(activeState,callback, lengthComments) {

if(lengthComments){
    commentsLength = lengthComments;
}
    if(activeState){
        commentsEnabled= false;

        scene.background = new THREE.Color(0x767676);
        callBackComment = callback;
        createCommentsDecays();



    }else {
        callBackComment = null;
        disablecomments();
        commentsEnabled = true;
        var pmremGenerator = new PMREMGenerator(renderer);
        pmremGenerator.compileEquirectangularShader();

        scene.background = new THREE.Color(0xf0f0f0);
        scene.background = hdrEquirectDefault;
        scene.environment = hdrEquirectDefault;





    }


}

///////////////////////////////////////////////////////////////////////////////////// EDIT MODELS

export function changeTexture(typeTexture, textureURL, masterProductUUID,versionProductUUID, setTextureInitCountCallback) {
    var model = scene;
        //("TF",model, textureURL,typeTexture);
    var loader = new THREE.TextureLoader();
    loader.crossOrigin = "";
console.log("CJANMGE TEXTURE", typeTexture, textureURL);
    if(model){
    if(textureURL !== "null" && textureURL !== null ){
        loader.load(
            textureURL,
            function( texture ) {
              texture.flipY= false;
                //texture.colorSpace = THREE.SRGBColorSpace;
                model.traverse(o => {
                    if (typeTexture == 'tabLaseredTexture') {
                        if (o.isMesh && (o.name === 'CAP_OPENER' || o.name === 'CAP_OPENER_HOLE' || o.name === 'CAP_OPENER_FULL')) {
                            o.material.normalMap = texture;
                            o.material.needsUpdate = true;
                        }
                    }
                    if (typeTexture == 'tabPunchedTexture') {
                        if (o.isMesh && (o.name === 'CAP_OPENER' || o.name === 'CAP_OPENER_HOLE' || o.name === 'CAP_OPENER_FULL')) {
                            o.material.normalMap = texture;
                            o.material.needsUpdate = true;
                        }
                    }
                    if (typeTexture == 'shellEmbossedTexture') {
                        if (o.isMesh && o.name === 'CAP') {
                            o.material.normalMap = texture;
                            o.material.needsUpdate = true;
                        }
                    }
                    if (typeTexture == 'shellIncisedTexture') {
                        if (o.isMesh && o.name === 'CAP') {
                            o.material.map = texture;
                            o.material.needsUpdate = true;
                        }
                    }

                    if (typeTexture === 'bodyPlasticCupTexture') {
                        if (o.isMesh &&( o.name === 'Body' || o.name === 'BODY' )) {


                            o.renderOrder = 5;
                            o.material.renderOrder = 5;


                            o.material.needsUpdate = true;
console.log("Material BODy", o.material);


                        }
                        if (o.isMesh &&( o.name === 'Label'  || o.name === 'LABEL_BODY'  || o.name === 'LABEK_BODY'  || o.name === 'Label_Main'  )) {



                            bodyMainTextureSaved =textureURL;

                            texture.colorSpace = THREE.SRGBColorSpace;

                            o.material.map = texture;
                            o.material.transparent = true;
                            o.renderOrder = 50;
                            o.material.renderOrder = 50;

                            console.log("Material Label", o.material);
                            o.material.needsUpdate = true;
                            if(setTextureInitCountCallback){
                                setTextureInitCountCallback();
                            }


                        }
                    }

                    if (typeTexture === 'bodyGBottleMainTexture') {

                        if (o.isMesh &&( o.name === 'Vicko')){

                            o.material.map = texture;
                            o.material.transparent = false;
                            o.material.needsUpdate = true;
                        }

                            if (o.isMesh &&( o.name === 'Label_TOP'  || o.name === 'LABEL_BODY'  || o.name === 'LABEK_BODY'  || o.name === 'Label_Main'  )) {


                                console.log("CJANMGE TEXTURE label uvnitr" , typeTexture, textureURL);

                            bodyMainTextureSaved =textureURL;

                            texture.colorSpace = THREE.SRGBColorSpace;
                            o.material.metalness = 0.6;

                                o.material.roughness = 0.35;
                                o.material.map = texture;
                            o.material.transparent = true;
                            o.renderOrder = 50;
                            o.material.renderOrder = 50;

                            o.material.needsUpdate = true;
                            if(setTextureInitCountCallback){
                                setTextureInitCountCallback();
                            }


                        }
                    }
                    if (typeTexture === 'bodyMainTexture') {

                        if (o.isMesh &&(o.name === 'BODY_1'  || o.name === 'BODY'  || o.name === 'Package'||  o.name === "mesh_0"  ||  o.name === "mesh_0_1" )) {


                        var textureLoader = new THREE.TextureLoader();
                        var textureRoughness = textureLoader.load('/textures/500mlStandard/metal2_2.jpg');
                        textureRoughness.flipY = false;


                        var textureMetalness = textureLoader.load('/textures/500mlStandard/metalnessTest.png');
                        textureMetalness.flipY = false;



                            bodyMainTextureSaved =textureURL;
                        // RGBEEncoding
                        //     LinearEncoding
                        //     GammaEncoding
                           texture.colorSpace = THREE.SRGBColorSpace;

                            o.material.map = texture;

                            o.material.needsUpdate = true;
                            if(setTextureInitCountCallback){
                                setTextureInitCountCallback();
                            }


                        }
                    }

                    if (typeTexture == 'bodyAlphaTexture' || typeTexture == 'bodyGBottleAlphaTexture' ||   typeTexture == 'bodyPlasticCupAlphaTexture') {
                        if (o.isMesh &&( o.name === 'BODY' )) {



                            o.material.renderOrder=10;
                          //  o.material.depthWrite = false;
                         // /  o.material.transparent=false;
                            o.material.side=THREE.DoubleSide;
                            o.material.needsUpdate = true;

                        }
                        if (o.isMesh &&( o.name === 'Label_TOP' ||o.name === 'Label'  || o.name === 'LABEL_BODY'  || o.name === 'LABEK_BODY'  || o.name === 'Label_Main'  )) {


                            bodyAlphaTextureSaved =textureURL;
                            texture.colorSpace = THREE.SRGBColorSpace;
                            o.material.alphaMap = texture;
                            o.material.depthWrite = false;
                            o.material.renderOrder=30;
                          //  o.material.envMap= envMap,
                            o.material.transparent=true;
                            o.material.side=THREE.DoubleSide;
                            o.material.needsUpdate = true;
                            if(setTextureInitCountCallback){
                                setTextureInitCountCallback();
                            }
                        }
                    }

                        if (typeTexture == 'bodyMetallicTexture' || typeTexture == 'bodyGBottleMetallicTexture' ||  typeTexture == 'bodyPlasticCupMetallicTexture' ) {

                            if(o.isMesh && o.name === 'BODY' && packageTypeGlobal === "cans"){
                                bodyMetallicTextureSaved =textureURL;
                                texture.colorSpace = THREE.SRGBColorSpace;
                            //    o.material.metalness = 0.8;
                          //      o.material.roughness = 0.2;
                                o.material.roughnessMap = texture;
                             //   o.material.metalnessMapIntensity = 1;
                               // o.material.metalness = 0.8;
                             //   o.material.envMap = hdrEquirect;
                             //   o.material.renderOrder=50;
                                o.material.needsUpdate = true;
                                if(setTextureInitCountCallback){
                                    setTextureInitCountCallback();
                                }
                            }
                        if (o.isMesh &&( o.name === 'Label_TOP'  || o.name === 'LABEL_BODY'  || o.name === 'LABEK_BODY'  || o.name === 'Label_Main' || o.name==="Label" )) {

                            bodyMetallicTextureSaved =textureURL;
                            texture.colorSpace = THREE.SRGBColorSpace;
                            o.material.metalness = 0.8;
                            o.material.roughness = 0.2;
                            o.material.metalnessMap = texture;
                            o.material.envMap = hdrEquirect;
                            o.material.renderOrder=30;
                            o.material.needsUpdate = true;
                            if(setTextureInitCountCallback){
                                setTextureInitCountCallback();
                            }
                        }
                            if (o.isMesh &&( o.name === 'BODY' )) {

                                o.renderOrder=3;
                                o.material.renderOrder=3;
                                o.material.needsUpdate = true;

                            }


                    }

                    if (o.isMesh &&( o.name === 'Vicko'   )){
                        o.material = new THREE.MeshStandardMaterial({
                            transparent:false,map:   o.material.map ,  envMap: envMap,
                            metalness: 0.25,  roughness : 0.4, aoMapIntensity : 0, emissiveIntensity : 0,
                            bumpScale: 0.15

                        });


                        o.material.needsUpdate = true;

                    }


                });

            },
            function () {},  // onProgress function
            function ( error ) {

                //
                } // onError function
        );

    } else {
        model.traverse(o => {

            if (typeTexture == 'tabLaseredTexture') {
                if (o.isMesh && (o.name === 'CAP_OPENER' || o.name === 'CAP_OPENER_HOLE' || o.name === 'CAP_OPENER_FULL')) {
                    if(textureURL === "null"){
                        o.material.map = null;
                        o.material.normalMap = null;
                        o.material.aoMapIntensity = 0;
                        o.material.emissiveIntensity = 0;
                        o.material.blending = 0;
                    }
                    o.material.needsUpdate = true;
                }
            }
            if (typeTexture == 'tabPunchedTexture') {
                if (o.isMesh && (o.name === 'CAP_OPENER' || o.name === 'CAP_OPENER_HOLE' || o.name === 'CAP_OPENER_FULL')) {
                    if(textureURL === "null"){
                        o.material.map = null;
                        o.material.normalMap = null;
                        o.material.aoMapIntensity = 0;
                        o.material.emissiveIntensity = 0;
                        o.material.blending = 0;
                    }
                    o.material.needsUpdate = true;
                }

            }
            if (typeTexture == 'shellEmbossedTexture') {
                if (o.isMesh && o.name === 'CAP') {
                    if(textureURL === "null"){
                        o.material.map = null;
                        o.material.normalMap = null;
                        o.material.aoMapIntensity = 0;
                        o.material.emissiveIntensity = 0;
                        o.material.blending = 0;
                    }

                    o.material.needsUpdate = true;
                }
            }
            if (typeTexture == 'shellIncisedTexture') {
                if (o.isMesh && o.name === 'CAP') {
                    if(textureURL === "null"){
                        o.material.map = null;
                        o.material.normalMap = null;
                        o.material.aoMapIntensity = 0;
                        o.material.emissiveIntensity = 0;
                        o.material.blending = 0;
                    }
                    o.material.needsUpdate = true;
                }
            }
            if (typeTexture == 'bodyFluorescentTexture' ||  typeTexture == 'bodyThermoTexture') {

                if (o.isMesh && o.name === 'BODY') {
                    if(textureURL === "null"){
                        o.material.emissiveMap = null;
                        o.material.emissive = new THREE.Color(0x000000);
                        o.material.emissiveIntensity = 0;
                    }
                    o.material.needsUpdate = true;
                }
            }

            if (typeTexture == 'bodyMetallicTexture') {

                if(o.isMesh && o.name === 'BODY' && packageTypeGlobal === "cans"){
                    o.material.roughnessMap = null;
                    o.material.needsUpdate = true;
                    if(setTextureInitCountCallback){
                        setTextureInitCountCallback();
                    }
                }

                if (o.isMesh &&( o.name === 'Label_TOP'  || o.name === 'LABEL_BODY'  || o.name === 'LABEK_BODY'  || o.name === 'Label_Main'  )) {
                    o.material.metalness = 0.8;
                    o.material.roughness = 0.2;
                    o.material.metalnessMap = null;
                    o.material.envMap = hdrEquirect;
                    o.material.renderOrder=50;
                    o.material.needsUpdate = true;
                    if(setTextureInitCountCallback){
                        setTextureInitCountCallback();
                    }
                }

            }

            if (typeTexture === 'bodyPlasticCupTexture') {

                if (o.isMesh &&( o.name === 'Label'  || o.name === 'LABEL_BODY'  || o.name === 'LABEK_BODY'  || o.name === 'Label_Main'  )) {
console.log("odstranuju texturu");
                    o.material.map = null;
                    o.material.needsUpdate = true;
                    if(setTextureInitCountCallback){
                        setTextureInitCountCallback();
                    }


                }
            }

            if (typeTexture === 'bodyGBottleMainTexture') {

                if (o.isMesh &&( o.name === 'Vicko')){

                    o.material.map = null;
                    // o.material.transparent = false;
                    o.material.needsUpdate = true;
                }

                if (o.isMesh &&( o.name === 'Label_TOP'  || o.name === 'LABEL_BODY'  || o.name === 'LABEK_BODY'  || o.name === 'Label_Main'  )) {


                    o.material.map = null;
                    o.material.needsUpdate = true;
                    if(setTextureInitCountCallback){
                        setTextureInitCountCallback();
                    }


                }
            }
            if (typeTexture === 'bodyMainTexture') {

                if (o.isMesh &&(o.name === 'BODY_1'  || o.name === 'BODY'  || o.name === 'Package'||  o.name === "mesh_0"  ||  o.name === "mesh_0_1" )) {

                    o.material.map = null;

                    o.material.needsUpdate = true;
                    if(setTextureInitCountCallback){
                        setTextureInitCountCallback();
                    }


                }
            }
            console.log("odstranuju texturu alpha ", typeTexture);
            if (typeTexture == 'bodyAlphaTexture' || typeTexture == 'bodyGBottleAlphaTexture' ||   typeTexture == 'bodyPlasticCupAlphaTexture') {
                // if (o.isMesh &&( o.name === 'BODY' )) {
                //
                //
                //
                //     o.material.renderOrder=10;
                //     //  o.material.depthWrite = false;
                //     // /  o.material.transparent=false;
                //     o.material.side=THREE.DoubleSide;
                //     o.material.needsUpdate = true;
                //
                // }
                console.log("Alpha mapo");
                if (o.isMesh &&( o.name === 'Label_TOP' ||o.name === 'Label'  || o.name === 'LABEL_BODY'  || o.name === 'LABEK_BODY'  || o.name === 'Label_Main'  )) {

                    o.material.alphaMap = null;
                    o.material.needsUpdate = true;
                    if(setTextureInitCountCallback){
                        setTextureInitCountCallback();
                    }
                }
            }

            if (typeTexture == 'bodyMetallicTexture' || typeTexture == 'bodyGBottleMetallicTexture' ||  typeTexture == 'bodyPlasticCupMetallicTexture' ) {

                if(o.isMesh && o.name === 'BODY' && packageTypeGlobal === "cans"){
                    o.material.metalnessMap = null;
                    o.material.needsUpdate = true;
                    if(setTextureInitCountCallback){
                        setTextureInitCountCallback();
                    }
                }
                if (o.isMesh &&( o.name === 'Label_TOP'  || o.name === 'LABEL_BODY'  || o.name === 'LABEK_BODY'  || o.name === 'Label_Main' || o.name==="Label" )) {

                    o.material.map = null;
                    o.material.needsUpdate = true;
                    if(setTextureInitCountCallback){
                        setTextureInitCountCallback();
                    }
                }
                if (o.isMesh &&( o.name === 'BODY' )) {

                    o.renderOrder=3;
                    o.material.renderOrder=3;
                    o.material.needsUpdate = true;

                }


            }



        });
    }

    }
    // Set image source
}
var rotationSetActive = false;
var typeOfRotation = "BODY";
export function onDocumentMouseMoveRotationUp() {
    rotationSetActive = false;
}
export function onDocumentMouseMoveRotationDown() {
    rotationSetActive = true;


}



var productVersionInsideRotation;
//var originalPositionY
export function setRotationMode(activeState, rotationFce, setProductVersionInsideRotationNew, productVersionInsideRotationNew) {
    setAngleRotation = rotationFce;

    if(!setProductVersionInsideRotation){
        setProductVersionInsideRotation = setProductVersionInsideRotationNew;
    }
    if(!productVersionInsideRotation){

        productVersionInsideRotationInner=productVersionInsideRotationNew;

    }

    if(activeState){
     console.log(fullHeightTotal, fullHeightTotal/2) ;
        /*var newX = 0- fullHeight;
        var newY = fullHeight+20;

        camera.position.set(0, newY, newX);
        new TWEEN.Tween(camera.position).to({
            x: 0,
            z: newX,
            y: newY
        }, 10).easing(TWEEN.Easing.Cubic.InOut).start();
        */


        if(TWEEN !== undefined){
            new TWEEN.Tween(camera.position).to({
                x: 0,
                z: (fullHeightTotal*-1)*2,
                y: fullHeightTotal/2
            }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
        }

        controls.target.set(0, fullHeightTotal/2, 0);
        controls.update();
        scene.background = new THREE.Color(0x767676);



        setTimeout(function(){
            controls.enabled = false;
            controls.enableRotate = false;
            controls.rotate = true;
            controls.update();

            document.getElementById("rotationCanvas").addEventListener('mousedown', onDocumentMouseMoveRotationDown);
            document.addEventListener('mouseup', onDocumentMouseMoveRotationUp);
        }, 300);





    }else {

        var pmremGenerator = new PMREMGenerator(renderer);
        pmremGenerator.compileEquirectangularShader();
        scene.background = new THREE.Color(0xf0f0f0);
        scene.background = hdrEquirectDefault;
        scene.environment = hdrEquirectDefault;


        controls.enabled = true;
        controls.enableRotate = true;
        controls.rotate = true;
        controls.update();

        document.getElementById("scene-container").removeEventListener('mousedown', onDocumentMouseMoveRotationDown);
        document.getElementById("scene-container").removeEventListener('mouseup', onDocumentMouseMoveRotationUp);

/// Priprava na shrinky
//
//         scene.getObjectByName("BODY").material.opacity = 1;
//         scene.getObjectByName("BODY").material.alpha = false;
//         scene.getObjectByName("BODY").material.depthTest = true;
//
//         //  scene.getObjectByName("BODY").renderOrder = 0;
//         scene.getObjectByName("BODY").material.transparent = false;
//         scene.getObjectByName("BODY").material.needsUpdate=true;

        if( scene.getObjectByName("BODY_CAN_500_1")){
            scene.getObjectByName("BODY_CAN_500_1").material.opacity = 1;
            scene.getObjectByName("BODY_CAN_500_1").material.alpha = false;
            scene.getObjectByName("BODY_CAN_500_1").material.transparent = false;
            scene.getObjectByName("BODY_CAN_500_1").material.needsUpdate=true;
        }

        if( scene.getObjectByName("BODY_CAN_500_2")){
            scene.getObjectByName("BODY_CAN_500_2").material.opacity = 1;
            scene.getObjectByName("BODY_CAN_500_2").material.alpha = false;
            scene.getObjectByName("BODY_CAN_500_2").material.transparent = false;
            scene.getObjectByName("BODY_CAN_500_2").material.needsUpdate=true;
        }

        if( scene.getObjectByName("BODY_CAN_500_3")){
            scene.getObjectByName("BODY_CAN_500_3").material.opacity = 1;
            scene.getObjectByName("BODY_CAN_500_3").material.alpha = false;
            scene.getObjectByName("BODY_CAN_500_3").material.transparent = false;
            scene.getObjectByName("BODY_CAN_500_3").material.needsUpdate=true;
        }
        if( scene.getObjectByName("BODY_CAN_500_4")){
            scene.getObjectByName("BODY_CAN_500_4").material.opacity = 1;
            scene.getObjectByName("BODY_CAN_500_4").material.alpha = false;
            scene.getObjectByName("BODY_CAN_500_4").material.transparent = false;
            scene.getObjectByName("BODY_CAN_500_4").material.needsUpdate=true;
        }
        if(scene.getObjectByName("BODY_CAN_500_5")){
            scene.getObjectByName("BODY_CAN_500_5").material.opacity = 1;
            scene.getObjectByName("BODY_CAN_500_5").material.alpha = false;
            scene.getObjectByName("BODY_CAN_500_5").material.transparent = false;
            scene.getObjectByName("BODY_CAN_500_5").material.needsUpdate=true;
        }

        if( scene.getObjectByName("BODY_CAN_500_6")){
            scene.getObjectByName("BODY_CAN_500_6").material.opacity = 1;
            scene.getObjectByName("BODY_CAN_500_6").material.alpha = false;
            scene.getObjectByName("BODY_CAN_500_6").material.transparent = false;
            scene.getObjectByName("BODY_CAN_500_6").material.needsUpdate=true;
        }

        if( scene.getObjectByName("BODY_CAN_500_7")){
            scene.getObjectByName("BODY_CAN_500_7").material.opacity = 1;
            scene.getObjectByName("BODY_CAN_500_7").material.alpha = false;
            scene.getObjectByName("BODY_CAN_500_7").material.transparent = false;
            scene.getObjectByName("BODY_CAN_500_7").material.needsUpdate=true;
        }

        if( scene.getObjectByName("BODY_CAN_500_8")){
            scene.getObjectByName("BODY_CAN_500_8").material.opacity = 1;
            scene.getObjectByName("BODY_CAN_500_8").material.alpha = false;
            scene.getObjectByName("BODY_CAN_500_8").material.transparent = false;
            scene.getObjectByName("BODY_CAN_500_8").material.needsUpdate=true;
        }

        if( scene.getObjectByName("BODY_CAN_500_9")){
            scene.getObjectByName("BODY_CAN_500_9").material.opacity = 1;
            scene.getObjectByName("BODY_CAN_500_9").material.alpha = false;
            scene.getObjectByName("BODY_CAN_500_9").material.transparent = false;
            scene.getObjectByName("BODY_CAN_500_9").material.needsUpdate=true;
        }
        if( scene.getObjectByName("BODY_CAN_500_10")){
            scene.getObjectByName("BODY_CAN_500_10").material.opacity = 1;
            scene.getObjectByName("BODY_CAN_500_10").material.alpha = false;
            scene.getObjectByName("BODY_CAN_500_10").material.transparent = false;
            scene.getObjectByName("BODY_CAN_500_10").material.needsUpdate=true;
        }

        if( scene.getObjectByName("BODY_CAN_500_11")){
            scene.getObjectByName("BODY_CAN_500_11").material.opacity = 1;
            scene.getObjectByName("BODY_CAN_500_11").material.alpha = false;
            scene.getObjectByName("BODY_CAN_500_11").material.transparent = false;
            scene.getObjectByName("BODY_CAN_500_11").material.needsUpdate=true;
        }

        if( scene.getObjectByName("BODY_CAN_500_12")){
            scene.getObjectByName("BODY_CAN_500_12").material.opacity = 1;
            scene.getObjectByName("BODY_CAN_500_12").material.alpha = false;
            scene.getObjectByName("BODY_CAN_500_12").material.transparent = false;
            scene.getObjectByName("BODY_CAN_500_12").material.needsUpdate=true;
        }




    }

}
export function setFluoTemp(fluoValue) {

    if(fluoValue){

        renderer.toneMappingExposure = 1;
        renderer.toneMapping = THREE.NoToneMapping;

        //
        // envMap: envMap,

        scene.traverse(function(element) {
            if (element.isLight) {

                if(element.name.includes("light15")){
                    element.intensity = 1.5;
                }
                if(element.name.includes("light07")){
                    element.intensity = 0.7;
                }
            }
            if(element.isMesh && element.material !== undefined){
                element.material.envMapIntensity = 1;
            }
        })


        // scene.getObjectByName("BODY").material.emissiveIntensity = 0;
        // scene.getObjectByName("BODY").material.needsUpdate = true;

    } else {
        // scene.background = null;
        renderer.toneMappingExposure = 0.40;
        renderer.toneMapping = THREE.CineonToneMapping;

        //
        // envMap: envMap,

        scene.traverse(function(element) {
            if (element.isLight) {
                element.intensity = 0.25;
            }
            if(element.isMesh && element.material !== undefined){
                element.material.envMapIntensity = 0.2;
            }

        });


        // renderer.setClearColor( 0x000000, 1);

      //  scene.background = new THREE.Color(0x000000);
       // scene.background = envMap;
       //  scene.environment = null;

        // scene.getObjectByName("BODY").material.emissiveIntensity = -1;
        // scene.getObjectByName("BODY").material.needsUpdate = true;
    }

}


export function setThermoTemp(thermoValue) {

    if(thermoValue){

        scene.getObjectByName("BODY").material.emissiveIntensity = 0;
        scene.getObjectByName("BODY").material.needsUpdate = true;
        if(scene.getObjectByName("Package") !== undefined){
            scene.getObjectByName("BODY").material.emissiveIntensity = 0;
            scene.getObjectByName("BODY").material.needsUpdate = true;
        }


    } else {

        scene.getObjectByName("BODY").material.emissiveIntensity = -1;
        scene.getObjectByName("BODY").material.needsUpdate = true;

        if(scene.getObjectByName("Package") !== undefined){
            scene.getObjectByName("BODY").material.emissiveIntensity = -1;
            scene.getObjectByName("BODY").material.needsUpdate = true;
        }
    }

    // Set image source
}

export function switchMatteMaterial(swtichToState) {


        var model = scene;
        if(model){
            if(scene.getObjectByName("BODY") !== undefined){
                if(swtichToState.toString() === "false" ){


                    // scene.getObjectByName("BODY").material.reflectivity = 1;
                    scene.getObjectByName("BODY").material.roughness = 0.35;
                    scene.getObjectByName("BODY").material.metalness = 0.6;
                    //  scene.getObjectByName("BODY").material.aoMap = null;

                    //    scene.getObjectByName("BODY").material.roughnessMap = null;
                    // scene.getObjectByName("BODY").material.roughness = 0.2;
                    scene.getObjectByName("BODY").material.needsUpdate = true;

                } else {

                    // scene.getObjectByName("BODY").material.reflectivity = 0;
                    scene.getObjectByName("BODY").material.roughness = 0.8;
                    scene.getObjectByName("BODY").material.metalness = 0.3;
                    scene.getObjectByName("BODY").material.needsUpdate = true;

                }
        }

}






    // Set image source
}

function encode(data) {
    var str = data.reduce(function(a, b) {
        return a + String.fromCharCode(b);
    }, '');
    return btoa(str).replace(/.{76}(?=.)/g, '$&\n');
}
export function switchEmissive() {
    var model = scene;

    model.traverse(o => {
        if (o.isMesh && o.name === 'BODY') {

            // var texture = new THREE.Texture(imageX);
            // texture.flipY = false;
            // On image load, update texture
            // imageX.onload = () =>  {
            //     texture.needsUpdate = true;
            //
            //     materials['basic'] = new THREE.MeshBasicMaterial( { color: 0xffaa00, transparent: true, blending: THREE.AdditiveBlending }

            var textureLoader = new THREE.TextureLoader();
            var texture = textureLoader.load('textures/emissiveMap.jpg');
            texture.flipY = false;

            o.material.emissiveMap = texture;
            o.material.needsUpdate = true;
            //o.material.metalnessMap = null;

            // note: for a multi-material mesh, `o.material` may be an array,
            // in which case you'd need to set `.map` on each value.
        }
    });
}

export function changeBackgroundColorGradient(gradientHDRUrl, gridColor, gridOpacityVar, gridActive)
{
    var pmremGenerator = new PMREMGenerator(renderer);
    pmremGenerator.compileEquirectangularShader();

    var enviromentVarX = "default.hdr";


    // if(color === "darkgray"){
    //     enviromentVarX = "gradient2.hdr";
    // }
    //
    // if(color === "lightgray"){
    //     enviromentVarX = "gradient1.hdr";
    // }


    // @ts-ignore
    new RGBELoader()
        .setDataType(THREE.HalfFloatType)
        .setPath('/textures/enviroment/')
        .load(gradientHDRUrl, function(texture: any) {
            var envMap = pmremGenerator.fromEquirectangular(texture).texture;
            scene.background = envMap;
            scene.environment = envMap;
            texture.dispose();
            pmremGenerator.dispose();
            render();
        });


    gridOpacity = gridOpacityVar;

    if(gridActive){
        scene.getObjectByName("GridScene").material.opacity = gridOpacity;
        scene.getObjectByName("GridScene").material.color.setHex('0x' + gridColor.replace("#",""));
        scene.getObjectByName("GridScene").material.needsUpdate = true;
    }



}
export function changeBackgroundColor(color, gridColor, gridOpacityVar, gridActive)
{
    scene.background = new THREE.Color(color);

    gridOpacity = gridOpacityVar;


    if(gridActive){
        scene.getObjectByName("GridScene").material.opacity = gridOpacity;
        scene.getObjectByName("GridScene").material.color.setHex('0x' + gridColor.replace("#",""));
        scene.getObjectByName("GridScene").material.needsUpdate = true;
    }


}
export function changeColorFluid(color) {
    var model = scene;

    if(model){
        model.traverse(o => {
            if (o.isMesh && (o.name === 'FLUID' )) {
                o.material.color.setHex('0x' + color.replace("#",""));
                o.material.needsUpdate = true;
            }
        });
    }

}
export function changeColorBody(color, opacity) {
    var model = scene;

    if(model){
        model.traverse(o => {
            if (o.isMesh && (o.name === 'BODY' )) {
                console.log("BODY?", color, opacity);
                o.material.color.setHex('0x' + color.replace("#",""));
                o.material.opacity = opacity;
                o.material.transparent = true;
                o.material.needsUpdate = true;
            }
        });
    }

}
export function changeColorBottle(color) {
    var model = scene;

    if(model){
        model.traverse(o => {
            if (o.isMesh && (o.name === 'BODY' )) {
                o.material.color.setHex('0x' + color.replace("#",""));
                o.material.needsUpdate = true;
            }
        });
    }

}
export function changeColorTab(color) {
    var model = scene;

    if(model){
        model.traverse(o => {
            if (o.isMesh && (o.name === 'CAP_OPENER' || o.name === 'CAP_OPENER_HOLE' || o.name === 'CAP_OPENER_FULL') || o.name.includes("tab_")) {
                o.material.color.setHex('0x' + color.replace("#",""));
                o.material.needsUpdate = true;
            }
        });
    }

}

export function switchCameras() {

    if(activeCamera === camera){


        if(isPlugin){
            // camera2.position.set(0,0,-30);
            // camera2.zoom = 18;
            //
            // camera2.position.set(0, 0, -15);
            //
            // camera2.updateProjectionMatrix();
            // camera2.lookAt(0,10,0);
            //
            updateCamera();
            baseRotationY=Math.PI;
            scene.rotation.y = Math.PI;
            scene.rotation.x = 0;
            console.log("ROTATIOAN ", camera.rotation);
            console.log("position ", camera.position);

            //
            console.log("ROTATIOAN 2", camera2.rotation);
            console.log("position 2", camera2.position);
            //
            if(packageTypeGlobal !== "glass-bottles"){
                camera2.rotation.set(0,0,30);
                if(packageTypeGlobal !== "plastic-drink-cups"){
                    camera2.zoom = 23;
                    camera2.position.set(0, fullHeightCamera/2, 6);
                    //
                    scene.position.set(0,-5,0);
                } else {
                    camera2.zoom = 23;
                    camera2.position.set(0, fullHeightCamera/2, 8);
                    //
                    scene.position.set(0,-4,0);
                }

                //
                console.log("ROTATIOAN3 ", camera2.rotation);
                console.log("position 3", camera2.position);

            } else {
                camera2.zoom = 18;
                camera2.position.set(0, fullHeightCamera/2, 6);
                //
                scene.position.set(0,-3,0);

                // camera2.zoom = 18;
                //
                // camera2.position.set(0,fullHeightCamera/2, -15);
                // scene.position.set(0,14,0);
            }
            camera2.lookAt(0,fullHeightCamera/2,0);
            camera2.updateProjectionMatrix();
            //  if(packageTypeGlobal !== "glass-bottles"){
           //      camera2.position.set(0, 0, -6);
           //  } else {
           //      camera2.position.set(0, 0, 15);
           //  }


        } else {
            camera2.rotation.copy(camera.rotation);
            if(controls){

                controls.target.set(0, 0, 0);
                controls.object = camera2;
                controls.update();

            }
        }



        camera2.updateProjectionMatrix();
        activeCamera=camera2;
    } else {


        if(isPlugin){
         //   camera.updateProjectionMatrix();
        } else {
            controls.object = camera;
            controls.update();
            camera.updateProjectionMatrix();



            setTimeout(function(){
                setUpControls(packageTypeGlobal);
            },5);
        }



      //  controls = null;


       // controls = new OrbitControls(camera, renderer.domElement);
        //camera.updateProjectionMatrix();
        activeCamera=camera;
    }

}
export function makeScreenshot(masterProductUUID,versionProductUUID, callback) {

}

export function takeScreenshot(masterProductUUID,versionProductUUID, callback, makeScreenshot, allComments, commentActive) {
    var cameraOriginalPosition = [camera.position.x, camera.position.y, camera.position.z];

    var originalGlassMaterial = null;
    var originalGlassMaterialColor = null;
    var originalBG = scene.background;
    scene.background = null;
    scene.background = null;
    scene.environment = null;
    scene.background = new THREE.Color(0xffffff);

    if(commentActive){
        removeDecals();
        disablecomments();
    }

console.log("FOTIME");
    //scene.environment = null;


    if(scene.getObjectByName("GridScene") !== undefined){
        if(TWEEN !== undefined){
            new TWEEN.Tween(scene.getObjectByName("GridScene").material).to({
                opacity: 0
            }, 2).easing(TWEEN.Easing.Linear.None).start();
        }
    }

    var originalMetalness = scene.getObjectByName("BODY").material.metalness;
    var originalMaterial;

console.log("WTF ",packageTypeGlobal, packageTypeGlobal === "plastic-drink-cups");

    if (packageTypeGlobal === "drink-cups"){

        originalMaterial = scene.getObjectByName("Label").material;

        scene.getObjectByName("Label").material = new THREE.MeshBasicMaterial( {
            color: scene.getObjectByName("Label").material.color,
            map : scene.getObjectByName("Label").material.map,
            alphaMap : scene.getObjectByName("Label").material.alphaMap,

            transparent: true,

        } );
        console.log("Dalsi inside", packageTypeGlobal, scene, originalMaterial,  scene.getObjectByName("Label").material);
    } else if (packageTypeGlobal === "plastic-drink-cups"){
        console.log("plastic-drink-cups", packageTypeGlobal, scene, scene.getObjectByName("Label").material);
        originalMaterial = scene.getObjectByName("Label").material;

        scene.getObjectByName("Label").material = new THREE.MeshBasicMaterial( {
            color: scene.getObjectByName("Label").material.color,
            map : scene.getObjectByName("Label").material.map,
            alphaMap : scene.getObjectByName("Label").material.alphaMap,

            transparent: false,

        } );
    } else if (packageTypeGlobal === "glass-bottles"){


        const textureLoader = new THREE.TextureLoader();
        const normalMapTexture = textureLoader.load("/textures/normal.jpg");
        normalMapTexture.wrapS = THREE.RepeatWrapping;
        normalMapTexture.wrapT = THREE.RepeatWrapping;
        normalMapTexture.repeat.set(3, 3);

        scene.getObjectByName("BODY").material = new THREE.MeshStandardMaterial( {
            color: scene.getObjectByName("BODY").material.color,
            metalness: 0.05,
            roughness: 0.05,
            ior: 1,
            thickness:  1,
            envMap: hdrEquirect,
            envMapIntensity: 1,
            transmission: 1, // use material.transmission for glass materials
            specularIntensity: 1,
            specularColor: 0xffffff,
            opacity: 0.7,
            side: THREE.DoubleSide,
            transparent: true,
      //      normalScale: new THREE.Vector2(0.2),
        //    normalMap: normalMapTexture,
            clearcoatNormalMap: normalMapTexture,
            clearcoatNormalScale: new THREE.Vector2(0.1),
        } );
        scene.getObjectByName("BODY").material.needsUpdate = true;

        originalMaterial = scene.getObjectByName("LABEL_BODY").material;

        scene.getObjectByName("LABEL_BODY").material = new THREE.MeshBasicMaterial( {
            color: scene.getObjectByName("LABEL_BODY").material.color,
            map : scene.getObjectByName("LABEL_BODY").material.map,
            alphaMap : scene.getObjectByName("LABEL_BODY").material.alphaMap,

            transparent: true,

        } );
        scene.getObjectByName("LABEL_BODY").material.needsUpdate = true;
        originalGlassMaterial =   new THREE.MeshPhysicalMaterial( {
            color: scene.getObjectByName("BODY").material.color,
            metalness: 0.05,
            roughness: 0.05,
            ior: 1,
            thickness:  1,
            envMap: hdrEquirect,
            envMapIntensity: 1,
            transmission: 1, // use material.transmission for glass materials
            specularIntensity: 1,
            specularColor: 0xffffff,
            opacity: 0.7,
            side: THREE.DoubleSide,
            transparent: true,
           // normalScale: new THREE.Vector2(0.2),
            //normalMap: normalMapTexture,
            clearcoatNormalMap: normalMapTexture,
            clearcoatNormalScale: new THREE.Vector2(0.1),
        } );



    } else {

            scene.getObjectByName("BODY").material.metalness = 0.5;
            scene.getObjectByName("BODY").material.needsUpdate = true;

    }



    if(scene.getObjectByName("shadoow")){
        scene.getObjectByName("shadoow").material.transparent = true;
        scene.getObjectByName("shadoow").material.opacity = 0;
        scene.getObjectByName("shadoow").material.needsUpdate = true;
        scene.getObjectByName("shadoow").needsUpdate = true;
    }
    setTimeout(function (){
console.log("package", packageTypeGlobal);
        scene.background = new THREE.Color(0xffffff);
        if(packageTypeGlobal !== "glass-bottles"){
console.log("TYPE ", packageTypeGlobal);

            if(packageTypeGlobal === "box"){
                camera2.zoom = 18;
                camera2.position.set(0, 0, -6);
                scene.position.set(0,-13,0);
            }
            else if(packageTypeGlobal === "doypacks"){
                camera2.zoom = 12;
                camera2.updateProjectionMatrix();

                camera2.position.set(0, 0, -30);
                scene.position.set(0,-23,0);
            } else {
                camera2.zoom = 23;
                camera2.position.set(0, 0, -6);
                scene.position.set(0,-13,0);
            }



            if(packageTypeGlobal === "doypacks"){
                camera2.zoom = 12;
                console.log("DOYPACKS");

                camera2.updateProjectionMatrix();

                camera2.position.set(0, 0, -30);
                scene.position.set(0,-23,0);
            } else {
                camera2.zoom = 23;
                camera2.position.set(0, 0, -6);
                scene.position.set(0,-13,0);
            }

        } else {


            camera2.zoom = 18;


            camera2.updateProjectionMatrix();

            camera2.position.set(0, 0, -15);
            scene.position.set(0,-16,0);
        }



        switchCameras();

        camera2.aspect = 400 /600;
        camera2.updateProjectionMatrix();

        renderer.setSize( 800, 1200 );
        var img = new Image();
      //  renderer.setClearColor( new THREE.Color(0x000080), 1 );
        renderer.clear();
        renderer.render( scene, activeCamera );
        renderer.render( scene, activeCamera );

      //  renderer.render( scene, activeCamera );
        renderer.render( scene, activeCamera );
        img.src = renderer.domElement.toDataURL();

// // Vložíme obrázek do dokumentu
//  document.body.appendChild(img);
//       img.style.width = "100%";

       if( makeScreenshot){

           var imgData = renderer.domElement.toDataURL("image/jpg");
           var link = document.createElement('a');
           link.href = imgData;
           link.download = 'quickPreviewPackshot.jpg';
           link.click();


        //   var w = window.open('', '');
          // w.document.title = "Screenshot";
           //w.document.body.style.backgroundColor = "gray";
           //w.document.body.appendChild(img);
       }
/*      var w = window.open('', '');
      w.document.title = "Screenshot";
     w.document.body.style.backgroundColor = "red";
*/
        // Without 'preserveDrawingBuffer' set to true, we must render now
        //  renderer.render(scene, camera);


       // w.document.body.appendChild(img);

        fetch(process.env.NEXT_PUBLIC_OBALERO_API_BASEPATH+"uploads/prepare-form", {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': "Bearer "+ getCookie('userTeam'), // notice the Bearer before your token
            },
        })
            .then(response => response.json())
            .then(function(data){
                if(data.message !== undefined){
                    Sentry.captureException("uploads/prepare-form"+": "+ data.message + " : " + getCookie("userMail"));
                }

                fetch(img.src)
                    .then(res => res.blob())
                    .then(blob => {
                        const file = new File([blob], "capture.jpg", {
                            type: 'image/jpg'
                        });
                     //   var fd = new FormData();
                   //     fd.append("file", file);



                        let formData = new FormData();
                        Object.keys(data.formInputs).forEach((key) => {
                            formData.append(key, data.formInputs[key]);
                        });
                        formData.append('file', file);
                        fetch(data.formAttributes.action, {
                            method: data.formAttributes.method,
                            /*    headers: {
                                    'Content-type': data.formAttributes.enctype
                                 },*/
                            body: formData,
                        })
                            .then(function(dataUpload){
console.log("CApture ",masterProductUUID, versionProductUUID);
                                fetch(process.env.NEXT_PUBLIC_OBALERO_API_BASEPATH+"products/"+masterProductUUID+"/versions/"+versionProductUUID, {
                                    method: 'PUT',
                                    body: JSON.stringify(    {
                                        "thumbnail_path": data.formInputs.key
                                    }),
                                    headers: {
                                        'Content-type': 'application/json',
                                        'Authorization': "Bearer "+ (isPlugin ? getCookie('pluginLoginSessionTeamToken') : getCookie('userTeam')), // notice the Bearer before your token
                                    },
                                })
                                    .then(response => response.json())
                                    .then(function(data){
                                        if(data.message !== undefined){
                                            Sentry.captureException("products/"+masterProductUUID+"/versions/"+versionProductUUID+": "+ data.message + " : " + getCookie("userMail"));
                                        }


                                    });


                            })
                            .catch(function(e){
                                Sentry.captureException(data.formAttributes.action+": "+ e + " : " + getCookie("userMail"));
                            });

                    });
            });


        if(typePluginInner){
            camera.aspect = container.clientWidth / container.clientHeight;
            camera.updateProjectionMatrix();

            renderer.setSize( container.clientWidth , container.clientHeight );
        } else{
            camera.aspect = window.innerWidth / window.innerHeight;
            camera.updateProjectionMatrix();

            renderer.setSize( window.innerWidth, window.innerHeight );
        }
        if(scene.getObjectByName("GridScene") !== undefined){

            if(TWEEN !== undefined){
                new TWEEN.Tween(scene.getObjectByName("GridScene").material).to({
                    opacity: gridOpacity
                }, 1).easing(TWEEN.Easing.Linear.None).start();
            }

            //   scene.getObjectByName("GridScene").visible = true;
        }


        switchCameras();


        if(scene.getObjectByName("shadoow")){
            scene.getObjectByName("shadoow").material.opacity = 0.23;
            scene.getObjectByName("shadoow").material.needsUpdate = true;
        }


        if (packageTypeGlobal === "drink-cups"){

            scene.getObjectByName("Label").material = originalMaterial;
            scene.getObjectByName("Label").material.needsUpdate = true;
        }else if (packageTypeGlobal === "plastic-drink-cups"){

            scene.getObjectByName("Label").material = originalMaterial;
            scene.getObjectByName("Label").material.needsUpdate = true;
        }  else if(packageTypeGlobal === "glass-bottles"){
            scene.getObjectByName("BODY").material = originalGlassMaterial;
            scene.getObjectByName("BODY").material.needsUpdate = true;

            scene.getObjectByName("LABEL_BODY").material = originalMaterial;
            scene.getObjectByName("LABEL_BODY").material.needsUpdate = true;

            fpsLowered=false;
        } else{

                scene.getObjectByName("BODY").material.metalness = originalMetalness;
                scene.getObjectByName("BODY").material.needsUpdate = true;

        }
      //  scene.getObjectByName("BODY").material.envMap = null;
        //scene.getObjectByName("BODY").material.needsUpdate = true;



console.log((fullHeightTotal/2)*-1, fullHeightTotal/2);

        if(TWEEN !== undefined){
console.log("Is plugin", isPlugin);
            if(isPlugin){

                new TWEEN.Tween(camera.position).to({
                    x: cameraOriginalPosition[0],
                    y: cameraOriginalPosition[1],
                    z: cameraOriginalPosition[2],
                }, 1).easing(TWEEN.Easing.Cubic.InOut).start();

            } else {
                new TWEEN.Tween(camera.position).to({
                    x: 0,
                    z: (fullHeightTotal*-1)*2,
                    y: fullHeightTotal/2
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();


                controls.target.set(0, fullHeightTotal/2, 0);

            }

            /*
            new TWEEN.Tween(camera.position).to({
                x: cameraOriginalPosition[0],
                y: cameraOriginalPosition[1],
                z: cameraOriginalPosition[2],
            }, 1).easing(TWEEN.Easing.Cubic.InOut).start();*/
        }

        camera.updateProjectionMatrix();

        var pmremGenerator = new THREE.PMREMGenerator(renderer);
        pmremGenerator.compileEquirectangularShader();

        if(commentActive){
            allComments.map(comment => {

               makeCommentOnPack(comment.position,null, comment.number );
            });
        }


        scene.position.set(0,0,0);
        setTimeout(function(){
            if(scene){
                scene.position.set(0,0,0);

                scene.background = new THREE.Color(0xf0f0f0);
                scene.background = hdrEquirectDefault;
                scene.environment = hdrEquirectDefault;
            }

                if(callback){
                    callback(false);
                }
            render();
        },200);

    }, 50);



}


export function changeColorShell(color) {

    var model = scene;
    if(model){
        model.traverse(o => {
            if (o.isMesh && (o.name === 'CAP' || o.name === 'CAP_PLATE' || o.name === 'PLATE' ||o.name === 'CAP_1' || o.name === 'CAP_2')) {
                o.material.color.setHex('0x' + color.replace("#",""));
                o.material.needsUpdate = true;
            }
        });
    }

}
export function changeColorOpening(color, opacity) {

    var model = scene;
    model.traverse(o => {
        if (o.isMesh && (o.name.includes("OPENING_") || o.name === 'cap_outside' || o.name === 'cap_outside_2' || o.name === 'cap_holder' ||  o.name === 'cap_holder_1' ||  o.name === 'cap_holder_2' || o.name === 'cap_outside_3' || o.name === 'opening_outside')) {


            o.material.color.setHex('0x' + color.replace("#",""));
            o.material.transparent = true;
            o.material.opacity = opacity;
            o.material.needsUpdate = true;


        }
    });
}

export function addNewTexture(typeTexture) {

}
///////////////////////////////////////////////////////////////////////////////////// EDIT MODELS


export function setUpShrinkProductRotation(productNumber, shrinkType, sideRotation) {

    scene.getObjectByName("BODY").material.opacity = 0.5;
    scene.getObjectByName("BODY").material.alpha = true;
    scene.getObjectByName("BODY").material.depthTest = true;

    scene.getObjectByName("BODY").material.transparent = true;
    scene.getObjectByName("BODY").material.needsUpdate=true;
    scene.getObjectByName("BODY").renderOrder=10;

    if( scene.getObjectByName("BODY_CAN_500_1")){
        scene.getObjectByName("BODY_CAN_500_1").material.opacity = 0.1;
        scene.getObjectByName("BODY_CAN_500_1").material.alpha = true;
        scene.getObjectByName("BODY_CAN_500_1").renderOrder=1;
        scene.getObjectByName("BODY_CAN_500_1").material.transparent = true;
        scene.getObjectByName("BODY_CAN_500_1").material.needsUpdate=true;
    }

    if( scene.getObjectByName("BODY_CAN_500_2")){
        scene.getObjectByName("BODY_CAN_500_2").material.opacity = 0.1;
        scene.getObjectByName("BODY_CAN_500_2").material.alpha = true;
        scene.getObjectByName("BODY_CAN_500_2").material.transparent = true;
        scene.getObjectByName("BODY_CAN_500_2").material.needsUpdate=true;
        scene.getObjectByName("BODY_CAN_500_2").renderOrder=1;
    }

    if( scene.getObjectByName("BODY_CAN_500_3")){
        scene.getObjectByName("BODY_CAN_500_3").material.opacity = 0.1;
        scene.getObjectByName("BODY_CAN_500_3").material.alpha = true;
        scene.getObjectByName("BODY_CAN_500_3").material.transparent = true;
        scene.getObjectByName("BODY_CAN_500_3").material.needsUpdate=true;
        scene.getObjectByName("BODY_CAN_500_3").renderOrder=1;
    }
    if( scene.getObjectByName("BODY_CAN_500_4")){
        scene.getObjectByName("BODY_CAN_500_4").material.opacity = 0.1;
        scene.getObjectByName("BODY_CAN_500_4").material.alpha = true;
        scene.getObjectByName("BODY_CAN_500_4").material.transparent = true;
        scene.getObjectByName("BODY_CAN_500_4").material.needsUpdate=true;
        scene.getObjectByName("BODY_CAN_500_4").renderOrder=1;
    }
    if(scene.getObjectByName("BODY_CAN_500_5")){
        scene.getObjectByName("BODY_CAN_500_5").material.opacity = 0.1;
        scene.getObjectByName("BODY_CAN_500_5").material.alpha = true;
        scene.getObjectByName("BODY_CAN_500_5").material.transparent = true;
        scene.getObjectByName("BODY_CAN_500_5").material.needsUpdate=true;
        scene.getObjectByName("BODY_CAN_500_5").renderOrder=1;
    }

    if( scene.getObjectByName("BODY_CAN_500_6")){
        scene.getObjectByName("BODY_CAN_500_6").material.opacity = 0.1;
        scene.getObjectByName("BODY_CAN_500_6").material.alpha = true;
        scene.getObjectByName("BODY_CAN_500_6").material.transparent = true;
        scene.getObjectByName("BODY_CAN_500_6").material.needsUpdate=true;
        scene.getObjectByName("BODY_CAN_500_6").renderOrder=1;
    }

    if( scene.getObjectByName("BODY_CAN_500_7")){
        scene.getObjectByName("BODY_CAN_500_7").material.opacity = 0.1;
        scene.getObjectByName("BODY_CAN_500_7").material.alpha = true;
        scene.getObjectByName("BODY_CAN_500_7").material.transparent = true;
        scene.getObjectByName("BODY_CAN_500_7").material.needsUpdate=true;
        scene.getObjectByName("BODY_CAN_500_7").renderOrder=1;
    }

    if( scene.getObjectByName("BODY_CAN_500_8")){
        scene.getObjectByName("BODY_CAN_500_8").material.opacity = 0.1;
        scene.getObjectByName("BODY_CAN_500_8").material.alpha = true;
        scene.getObjectByName("BODY_CAN_500_8").material.transparent = true;
        scene.getObjectByName("BODY_CAN_500_8").material.needsUpdate=true;
        scene.getObjectByName("BODY_CAN_500_8").renderOrder=1;
    }

    if( scene.getObjectByName("BODY_CAN_500_9")){
        scene.getObjectByName("BODY_CAN_500_9").material.opacity = 0.1;
        scene.getObjectByName("BODY_CAN_500_9").material.alpha = true;
        scene.getObjectByName("BODY_CAN_500_9").material.transparent = true;
        scene.getObjectByName("BODY_CAN_500_9").material.needsUpdate=true;
        scene.getObjectByName("BODY_CAN_500_9").renderOrder=1;
    }
    if( scene.getObjectByName("BODY_CAN_500_10")){
        scene.getObjectByName("BODY_CAN_500_10").material.opacity = 0.1;
        scene.getObjectByName("BODY_CAN_500_10").material.alpha = true;
        scene.getObjectByName("BODY_CAN_500_10").material.transparent = true;
        scene.getObjectByName("BODY_CAN_500_10").material.needsUpdate=true;
        scene.getObjectByName("BODY_CAN_500_10").renderOrder=1;
    }

    if( scene.getObjectByName("BODY_CAN_500_11")){
        scene.getObjectByName("BODY_CAN_500_11").material.opacity = 0.1;
        scene.getObjectByName("BODY_CAN_500_11").material.alpha = true;
        scene.getObjectByName("BODY_CAN_500_11").material.transparent = true;
        scene.getObjectByName("BODY_CAN_500_11").material.needsUpdate=true;
        scene.getObjectByName("BODY_CAN_500_11").renderOrder=1;
    }

    if( scene.getObjectByName("BODY_CAN_500_12")){
        scene.getObjectByName("BODY_CAN_500_12").material.opacity = 0.1;
        scene.getObjectByName("BODY_CAN_500_12").material.alpha = true;
        scene.getObjectByName("BODY_CAN_500_12").material.transparent = true;
        scene.getObjectByName("BODY_CAN_500_12").material.needsUpdate=true;
        scene.getObjectByName("BODY_CAN_500_12").renderOrder=1;
    }


    typeOfRotation = "BODY";


    if(productNumber == "1"){
        scene.getObjectByName("BODY_CAN_500_1").material.opacity = 0.8;


        scene.getObjectByName("BODY_CAN_500_1").material.needsUpdate=true;
        typeOfRotation = "can1";


    }

    if(productNumber == "2"){
        scene.getObjectByName("BODY_CAN_500_2").material.opacity = 1;
        scene.getObjectByName("BODY_CAN_500_2").material.needsUpdate=true;
        typeOfRotation = "can2";

    }

    if(productNumber == "3"){
        typeOfRotation = "can3";
        scene.getObjectByName("BODY_CAN_500_3").material.opacity = 1;
        scene.getObjectByName("BODY_CAN_500_3").material.needsUpdate=true;

    }

    if(productNumber == "4"){
        typeOfRotation = "can4";
        scene.getObjectByName("BODY_CAN_500_4").material.opacity = 1;
        scene.getObjectByName("BODY_CAN_500_4").material.needsUpdate=true;

    }
    if(productNumber == "5"){
        typeOfRotation = "can5";
        scene.getObjectByName("BODY_CAN_500_5").material.opacity = 1;
        scene.getObjectByName("BODY_CAN_500_5").material.needsUpdate=true;


    }
    if(productNumber == "6"){
        typeOfRotation = "can6";
        scene.getObjectByName("BODY_CAN_500_6").material.opacity = 1;
        scene.getObjectByName("BODY_CAN_500_6").material.needsUpdate=true;


    }
    if(productNumber == "7"){
        typeOfRotation = "can7";
        scene.getObjectByName("BODY_CAN_500_7").material.opacity = 1;
        scene.getObjectByName("BODY_CAN_500_7").material.needsUpdate=true;


    }
    if(productNumber == "8"){
        typeOfRotation = "can8";
        scene.getObjectByName("BODY_CAN_500_8").material.opacity = 1;
        scene.getObjectByName("BODY_CAN_500_8").material.needsUpdate=true;

    }

    if(productNumber == "9"){
        typeOfRotation = "can9";
        scene.getObjectByName("BODY_CAN_500_9").material.opacity = 1;
        scene.getObjectByName("BODY_CAN_500_9").material.needsUpdate=true;

    }

    if(productNumber == "10"){
        typeOfRotation = "can10";
        scene.getObjectByName("BODY_CAN_500_10").material.opacity = 1;
        scene.getObjectByName("BODY_CAN_500_10").material.needsUpdate=true;

    }


    if(productNumber == "11"){
        typeOfRotation = "can11";
        scene.getObjectByName("BODY_CAN_500_11").material.opacity = 1;
        scene.getObjectByName("BODY_CAN_500_11").material.needsUpdate=true;

    }

    if(productNumber == "12"){
        typeOfRotation = "can12";
        scene.getObjectByName("BODY_CAN_500_12").material.opacity = 1;
        scene.getObjectByName("BODY_CAN_500_12").material.needsUpdate=true;


    }



    if(shrinkType === "4" && sideRotation === "SideA"){

        if(productNumber == "1"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: 60,
                    z: 30,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }

        }

        if(productNumber == "2"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: -60,
                    z: 30,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }

        if(productNumber == "3"){

            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: 60,
                    z: -30,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }

        if(productNumber == "4"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: -60,
                    z: 30,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }

    }

    if(shrinkType === "4" && sideRotation === "SideB"){

        if(productNumber == "1"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: -60,
                    z: -30,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }

        }

        if(productNumber == "2"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: 60,
                    z: -30,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }

        if(productNumber == "3"){

            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: -60,
                    z: 30,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }

        if(productNumber == "4"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: 60,
                    z: -30,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }

    }

    if(shrinkType === "6"){

        if(productNumber == "1"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: 60,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }

        }

        if(productNumber == "2"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: 60,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }

        if(productNumber == "3"){

            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: -60,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }

        if(productNumber == "4"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: -60,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }
        if(productNumber == "5"){

            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: -60,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }
        if(productNumber == "6"){

            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: -60,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }
        if(productNumber == "7"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: 0,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }
        if(productNumber == "8"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: -60,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }

        if(productNumber == "9"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: 0,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }

        if(productNumber == "10"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: 0,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }


        if(productNumber == "11"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: 0,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }

        if(productNumber == "12"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: 0,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }
    }
    if(shrinkType === "8"){

        if(productNumber == "1"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: 60,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }

        }

        if(productNumber == "2"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: 60,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }

        if(productNumber == "3"){

            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: -60,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }

        if(productNumber == "4"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: -60,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }
        if(productNumber == "5"){

            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: -60,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }
        if(productNumber == "6"){

            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: -60,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }
        if(productNumber == "7"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: 0,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }
        if(productNumber == "8"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: -60,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }

        if(productNumber == "9"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: 0,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }

        if(productNumber == "10"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: 0,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }


        if(productNumber == "11"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: 0,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }

        if(productNumber == "12"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: 0,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }
    }

    if(shrinkType === "12"){

        if(productNumber == "1"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: 60,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }

        }

        if(productNumber == "2"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: 60,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }

        if(productNumber == "3"){

            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: -60,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }

        if(productNumber == "4"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: -60,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }
        if(productNumber == "5"){

            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: -60,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }
        if(productNumber == "6"){

            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: -60,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }
        if(productNumber == "7"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: 0,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }
        if(productNumber == "8"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: -60,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }

        if(productNumber == "9"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: 0,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }

        if(productNumber == "10"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: 0,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }


        if(productNumber == "11"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: 0,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }

        if(productNumber == "12"){
            if(TWEEN !== undefined){
                new TWEEN.Tween(camera.position).to({
                    x: 0,
                    z: 60,
                    y: 18
                }, 300).easing(TWEEN.Easing.Cubic.InOut).start();
            }
        }
    }




}
